{
  "addons.addonList": "Csatlakoztatott egységek",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Hozzon létre és kérjen le API-kulcsot erről a linkről",
  "addons.ambientWeatherDescription": "Környezeti időjárási állomások (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API kulcs",
  "addons.applicationKey": "Alkalmazáskulcs",
  "addons.connect": "Kapcsolódás",
  "addons.davisApiSecret": "Titkos API",
  "addons.davisApiV2Key": "API-kulcs V2",
  "addons.davisDescription": "Davis meteorológiai állomások (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Töltse le a V2 API-kulcsokat erről a linkről",
  "addons.disconnect": "Lecsatlakozás",
  "addons.ecowittCreateAndRetrieveKeys": "Hozzon létre és kérjen le API-kulcsot és alkalmazáskulcsot erről a linkről",
  "addons.ecowittDescription": "Az Ecowitt professzionális meteorológiai állomásokat, vezeték nélküli beltéri/kültéri hőmérőket, nagy pontosságú esőmérőket, levegőminőség-érzékelőket és még sok mást kínál.",
  "addons.helpLink": "A(z) {provider} csatlakoztatása",
  "addons.myAcuriteAccountOnHold": "Fiókját felfüggesztettük. Kérjük, adja meg jelszavát a fiók újracsatlakozásához",
  "addons.myAcuriteDescription": "Az AcuRite az első számú meteorológiai állomás márka Észak-Amerikában. Az idő-, hőmérséklet- és időjárástechnológiában vezető szerepet betöltő AcuRite részletes információkat nyújt bel- és kültéri környezetéről, így magabiztosan tervezheti a napját.",
  "addons.myAcuriteEnterCredentials": "Adja meg My AcuRite hitelesítő adatait, hogy összekapcsolja My AcuRite fiókját a SmartMixinnel",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "A Netatmo Thermostat segítségével akár a világ másik feléről is szabályozhatja otthona fűtését.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Az okos időjárás állomás",
  "addons.or": "vagy",
  "addons.providerAccountDisconnected": "Az időjárás-szolgáltatáshoz való kapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "addons.reconnect": "Újrakapcsolódás",
  "addons.weatherflowCreateToken": "Hozza létre és kérje le a tokent erről a linkről",
  "addons.weatherflowTempestDescription": "A Weatherflow által kifejlesztett vihar meteorológiai állomás",
  "addons.wundergroundApiKey": "API kulcs",
  "addons.wundergroundDescription": "A Weather Underground egy olyan emberek globális közössége, akik környezeti érzékelőktől, például időjárás-állomásoktól és levegőminőség-figyelőktől származó adatokat kapcsolnak össze, hogy gazdag, hiperlokális adatokat szállíthassunk, amelyekre szüksége van szenvedélyeinek táplálásához.",
  "addons.wundergroundRetrieveApiKey": "Töltse le az API-kulcsot erről a linkről",
  "addons.wundergroundRetrieveStationId": "Az állomásazonosító (ID) lekérése erről a linkről",
  "addons.wundergroundStationId": "Állomásazonosító",
  "airQuality.adviceActivityGood": "Ideális nap a szabadtéri mozgáshoz",
  "airQuality.adviceActivityHazardous": "Kerüljön minden szabadtéri fizikai tevékenységet",
  "airQuality.adviceActivityLabel": "Fizikai aktivitás",
  "airQuality.adviceActivityModerate": "Jó nap a szabadtéri mozgáshoz",
  "airQuality.adviceActivitySensitive": "Fontolja meg a rövidebb és kevésbé intenzív szabadtéri tevékenységet",
  "airQuality.adviceActivityUnhealthy": "Csökkentse a hosszú vagy intenzív tevékenységeket, és tartson több szünetet",
  "airQuality.adviceActivityVeryUnhealthy": "Kerülje a hosszú vagy intenzív tevékenységeket; fontolja meg a beltérbe helyezésüket",
  "airQuality.adviceGroupsGood": "Nincs szükség különleges óvintézkedésre",
  "airQuality.adviceGroupsHazardous": "Maradjon beltérben, és tartsa alacsonyan az aktivitást",
  "airQuality.adviceGroupsLabel": "Érzékeny csoportok",
  "airQuality.adviceGroupsModerate": "Különösen érzékeny személyek: rövidebb és kevésbé intenzív tevékenység",
  "airQuality.adviceGroupsSensitive": "Rövidebb és kevésbé intenzív szabadtéri tevékenység, több szünettel",
  "airQuality.adviceGroupsUnhealthy": "Kerülje a hosszú vagy intenzív szabadtéri tevékenységeket; fontolja meg a beltérbe helyezésüket",
  "airQuality.adviceGroupsVeryUnhealthy": "Kerüljön minden szabadtéri fizikai tevékenységet; halassza el vagy helyezze beltérbe",
  "airQuality.adviceTimingLabel": "Mikor menjen ki",
  "airQuality.adviceTimingMorning": "Lehetőleg délelőtt — ilyenkor alacsonyabb az ózonszint",
  "airQuality.airQuality": "Levegő minősége",
  "airQuality.airQualityIndex": "Levegőminőségi index",
  "airQuality.aqiForecast": "Levegőminőség-előrejelzés",
  "airQuality.co": "Szén-monoxid",
  "airQuality.dailyForecast": "Napi előrejelzés",
  "airQuality.details": "Részletek",
  "airQuality.dominantPollutant": "Domináns szennyező anyag",
  "airQuality.expectedPeak": "Várható csúcs",
  "airQuality.good": "Jó",
  "airQuality.goodDescription": "A levegő minősége kielégítőnek tekinthető, és a légszennyezés csekély vagy egyáltalán nem jelent kockázatot.",
  "airQuality.hazardous": "Veszélyes",
  "airQuality.hazardousDescription": "Egészségügyi figyelmeztetés: Bárki tapasztalhat komolyabb egészségügyi hatásokat.",
  "airQuality.indoorAirQuality": "Beltéri levegő minősége",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Mérsékelt",
  "airQuality.moderateDescription": "A levegő minősége elfogadható. Egyes szennyező anyagok azonban egészségügyi kockázatot jelenthetnek nagyon kis számú, a levegőszennyezésre szokatlanul érzékeny ember számára.",
  "airQuality.no2": "Nitrogén-dioxid",
  "airQuality.noForecastForLocation": "Ehhez a helyhez nem érhető el levegőminőségi előrejelzés.",
  "airQuality.now": "Most",
  "airQuality.o3": "Ózon",
  "airQuality.pm10": "10 μm-nél kisebb részecske",
  "airQuality.pm25": "2,5 μm-nél kisebb részecske",
  "airQuality.pollutants": "Szennyezőanyagok",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Ajánlások",
  "airQuality.sensitiveUnhealthy": "Rossz az érzékeny csoportoknak",
  "airQuality.sensitiveUnhealthyDescription": "A levegő minősége elfogadható; Egyes szennyező anyagok azonban mérsékelt egészségügyi aggodalmat jelenthetnek nagyon kis számú, a légszennyezésre különösen érzékeny ember számára.",
  "airQuality.so2": "A kén-dioxid",
  "airQuality.subIndex": "AQI részindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Az index értelmezése",
  "airQuality.unhealthy": "Rossz",
  "airQuality.unhealthyDescription": "Bárki érezheti az egészségügyi hatásokat; az érzékeny csoportok tagjai súlyosabb egészségügyi hatásokat tapasztalhatnak.",
  "airQuality.veryUnhealthy": "Nagyon rossz",
  "airQuality.veryUnhealthyDezscription": "Egészségügyi figyelmeztetések vészhelyzetekre. Valószínűbb, hogy az egész lakosságot érinti.",
  "alerts.addAlert": "Figyelmeztetés hozzáadása",
  "alerts.addCondition": "Feltétel hozzáadása",
  "alerts.alertAdded": "A figyelmeztetés sikeresen hozzáadva",
  "alerts.alertAuthorizationNotice": "A riasztások csak akkor működnek, ha engedélyezi a SmartMixin számára az értesítések megjelenítését",
  "alerts.alertDeleted": "A figyelmeztetés sikeresen törölve",
  "alerts.alertEdited": "A figyelmeztetés sikeresen módosítva",
  "alerts.alertName": "Figyelmeztető név",
  "alerts.alertWhen": "riasztani akarok",
  "alerts.aqiGreaterThan": "AQI nagyobb, mint",
  "alerts.aqiGreaterThanThreshold": "Az AQI {value}{unit} küszöbérték felett van",
  "alerts.aqiLessThan": "AQI kevesebb, mint",
  "alerts.aqiLessThanThreshold": "Az AQI {value}{unit} küszöb alatt van",
  "alerts.atLeastOneCondition": "Legalább egy feltételt hozzá kell adni",
  "alerts.co2GreaterThan": "CO2 nagyobb, mint",
  "alerts.co2GreaterThanThreshold": "CO2 a(z) {value}{unit} küszöbérték felett",
  "alerts.co2LessThan": "CO2 kevesebb, mint",
  "alerts.co2LessThanThreshold": "CO2 a(z) {value}{unit} küszöb alatt",
  "alerts.conditions": "Feltételek",
  "alerts.createAlert": "Figyelmeztetés létrehozása",
  "alerts.dailyPrecipitationGreaterThan": "Napi csapadék nagyobb, mint",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Napi csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.deleteAlert": "Figyelmeztetés törlése",
  "alerts.editAlert": "Figyelmeztetés szerkesztése",
  "alerts.editCondition": "Állapot módosítása",
  "alerts.gustSpeedGreaterThan": "A széllökés nagyobb, mint",
  "alerts.gustSpeedGreaterThanThreshold": "A széllökés meghaladja a {value}{unit} küszöbértéket",
  "alerts.gustSpeedLessThan": "A széllökések kisebbek, mint",
  "alerts.gustSpeedLessThanThreshold": "A széllökés {value}{unit} küszöb alatt van",
  "alerts.heatIndexGreaterThan": "Hőindex több, mint",
  "alerts.heatIndexGreaterThanThreshold": "A Hőindex meghaladja a {value}{unit} küszöbértéket",
  "alerts.heatIndexLessThan": "Hőindex kevesebb, mint",
  "alerts.heatIndexLessThanThreshold": "A Hőindex {value}{unit} küszöb alatt van",
  "alerts.humidexGreaterThan": "Humidex több, mint",
  "alerts.humidexGreaterThanThreshold": "A Humidex meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidexLessThan": "Humidex kevesebb, mint",
  "alerts.humidexLessThanThreshold": "A Humidex {value}{unit} küszöb alatt van",
  "alerts.humidityGreaterThan": "Páratartalom fent",
  "alerts.humidityGreaterThanThreshold": "A páratartalom meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidityLessThan": "Páratartalom lent",
  "alerts.humidityLessThanThreshold": "A páratartalom {value}{unit} küszöb alatt van",
  "alerts.inProgress": "Folyamatban",
  "alerts.myAlerts": "Saját figyelmeztetéseim",
  "alerts.noConfiguredAlert": "Még nincs figyelmeztetése, adjon hozzá egyet",
  "alerts.noiseGreaterThan": "Zaj nagyobb, mint",
  "alerts.noiseGreaterThanThreshold": "Zaj meghaladja a(z) {value}{unit} küszöbértéket",
  "alerts.noiseLessThan": "Zaj kisebb, mint",
  "alerts.noiseLessThanThreshold": "Zaj {value}{unit} küszöb alatt",
  "alerts.noteOnConditions": "Vegye figyelembe, hogy a riasztás akkor aktiválódik, ha az alábbi feltételek mindegyike érvényesül",
  "alerts.noTriggerHistory": "Ez a riasztás még nem aktiválódott.",
  "alerts.pm10GreaterThan": "PM 10 nagyobb, mint",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} küszöbérték felett",
  "alerts.pm10LessThan": "PM 10 kevesebb mint",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} küszöb alatt van",
  "alerts.pm1GreaterThan": "PM 1 nagyobb, mint",
  "alerts.pm1GreaterThanThreshold": "PM 1 a {value}{unit} küszöbérték felett",
  "alerts.pm1LessThan": "PM 1 kevesebb mint",
  "alerts.pm1LessThanThreshold": "PM 1 a {value}{unit} küszöb alatt van",
  "alerts.pm2p5GreaterThan": "PM 2,5 nagyobb, mint",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 a {value}{unit} küszöbérték felett",
  "alerts.pm2p5LessThan": "PM 2,5 kevesebb, mint",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 a {value}{unit} küszöb alatt",
  "alerts.postStormSummary": "Esőzés összegzése",
  "alerts.postStormSynopsisHelper": "Minden esőzés végén összegző értesítést kap.",
  "alerts.postStormSynopsisSoleCondition": "A vihar utáni összefoglaló nem kombinálható más feltételekkel.",
  "alerts.precipitationGreaterThan": "Óránkénti csapadék nagyobb, mint",
  "alerts.precipitationGreaterThanThreshold": "Óránkénti csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.pressureGreaterThan": "Nyomás nagyobb, mint",
  "alerts.pressureGreaterThanThreshold": "Nyomás a(z) {value}{unit} küszöbérték felett",
  "alerts.pressureLessThan": "Nyomás kisebb, mint",
  "alerts.pressureLessThanThreshold": "A nyomás {value}{unit} küszöb alatt van",
  "alerts.rainRateGreaterThan": "Eső intenzitása nagyobb, mint",
  "alerts.rainRateGreaterThanThreshold": "Eső intenzitása meghaladja a {value}{unit} küszöbértéket",
  "alerts.solarRadiationGreaterThan": "A napsugárzás nagyobb, mint",
  "alerts.solarRadiationGreaterThanThreshold": "A napsugárzás meghaladja a {value}{unit} küszöbértéket",
  "alerts.solarRadiationLessThan": "A napsugárzás kevesebb, mint",
  "alerts.solarRadiationLessThanThreshold": "A napsugárzás {value}{unit} küszöbérték alatt van",
  "alerts.stormChartUnavailable": "Ehhez az esőzéshez nem érhető el csapadéktörténet.",
  "alerts.stormDetail": "Esőzés összegzése",
  "alerts.stormDuration": "Időtartam",
  "alerts.stormEnd": "Vége",
  "alerts.stormPeakRate": "Legnagyobb esőintenzitás",
  "alerts.stormStart": "Kezdete",
  "alerts.stormTotal": "Összes csapadék",
  "alerts.temperatureGreaterThan": "Fölötti hőmérséklet",
  "alerts.temperatureGreaterThanThreshold": "A hőmérséklet meghaladja a {value}{unit} küszöbértéket",
  "alerts.temperatureLessThan": "Hőmérséklet lent",
  "alerts.temperatureLessThanThreshold": "A hőmérséklet {value}{unit} küszöb alatt van",
  "alerts.thswGreaterThan": "THSW több, mint",
  "alerts.thswGreaterThanThreshold": "A THSW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thswLessThan": "THSW kevesebb, mint",
  "alerts.thswLessThanThreshold": "A THSW {value}{unit} küszöb alatt van",
  "alerts.thwGreaterThan": "THW több, mint",
  "alerts.thwGreaterThanThreshold": "A THW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thwLessThan": "THW kevesebb, mint",
  "alerts.thwLessThanThreshold": "A THW {value}{unit} küszöb alatt van",
  "alerts.triggerHistory": "Riasztási előzmények",
  "alerts.uvGreaterThan": "UV nagyobb, mint",
  "alerts.uvGreaterThanThreshold": "UV a {value}{unit} küszöbérték felett",
  "alerts.uvLessThan": "UV alacsonyabb, mint",
  "alerts.uvLessThanThreshold": "UV a {value}{unit} küszöb alatt",
  "alerts.visibilityGreaterThanThreshold": "A láthatóság meghaladja a {value}{unit} küszöbértéket",
  "alerts.visibilityLessThanThreshold": "A láthatóság {value}{unit} küszöb alatt van",
  "alerts.visiblityGreaterThan": "Láthatóság nagyobb, mint",
  "alerts.visiblityLessThan": "Láthatósága kisebb, mint",
  "alerts.whichMeasure": "Melyik mérésre szeretne figyelmeztetést kapni?",
  "alerts.whichModule": "Melyik modulra szeretne figyelmeztetni?",
  "alerts.windChillGreaterThan": "Szélhűtés több, mint",
  "alerts.windChillGreaterThanThreshold": "A Szélhűtés meghaladja a {value}{unit} küszöbértéket",
  "alerts.windChillLessThan": "Szélhűtés kevesebb, mint",
  "alerts.windChillLessThanThreshold": "A Szélhűtés {value}{unit} küszöb alatt van",
  "alerts.windSpeedGreaterThan": "A szél nagyobb mint",
  "alerts.windSpeedGreaterThanThreshold": "Szél {value}{unit} küszöb felett",
  "alerts.windSpeedLessThan": "A szél kisebb, mint",
  "alerts.windSpeedLessThanThreshold": "A szél {value}{unit} küszöb alatt van",
  "astral.aboveHorizonAllDay": "Egész nap a horizont felett",
  "astral.aboveTheHorizon": "a horizont felett",
  "astral.apparentSize": "Látszó méret",
  "astral.apparentSizeAcross": "{size} átmérőjű",
  "astral.astronomicalDawn": "Csillagászati hajnal",
  "astral.astronomicalDusk": "Csillagászati alkony",
  "astral.astronomicalSunPhase": "{sunPhase} csillagászati",
  "astral.belowHorizonAllDay": "Egész nap a horizont alatt",
  "astral.belowHorizonSince": "{time} óta a horizont alatt",
  "astral.belowHorizonSinceOn": "{day} {time} óta a horizont alatt",
  "astral.brightAllNight": "Egész éjjel világos — soha nem lesz teljesen sötét",
  "astral.brightestMoment": "Legvilágosabb pillanat",
  "astral.civilDawn": "Polgári hajnal",
  "astral.civilDusk": "Polgári alkony",
  "astral.civilSunPhase": "{sunPhase} civil",
  "astral.darkSkyBetween": "Sötét égbolt {from} → {to}",
  "astral.darkSkyWindow": "Sötét égbolt {from} → {to} · {duration} Hold nélkül",
  "astral.dawn": "Hajnal",
  "astral.dayLength": "Nappal hossza",
  "astral.daylightThroughTheYear": "Nappalhossz az év során",
  "astral.dayOfCycle": "{total} napból {day}",
  "astral.doesNotOccurToday": "Ma nem következik be",
  "astral.domeHint": "Húzd végig az éjszakán",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Szürkület",
  "astral.earliestSunrise": "Legkorábbi napkelte",
  "astral.earliestSunset": "Legkorábbi napnyugta",
  "astral.equinox": "Napéjegyenlőség",
  "astral.equinoxIn": "Napéjegyenlőség {days} nap múlva",
  "astral.evening": "Este",
  "astral.exactPhaseAt": "Pontosan {time}-kor",
  "astral.firstQuarter": "Első negyed",
  "astral.firstSunriseIn": "Első napkelte {days} nap múlva",
  "astral.firstSunsetIn": "Első napnyugta {days} nap múlva",
  "astral.fullMoon": "Telihold",
  "astral.goldenHourBegins": "Aranyóra kezdete",
  "astral.goldenHourEnds": "Aranyóra vége",
  "astral.highestPoint": "Legmagasabb pont",
  "astral.inDays": "{days} nap múlva",
  "astral.lastQuarter": "Utolsó negyed",
  "astral.latestSunrise": "Legkésőbbi napkelte",
  "astral.latestSunset": "Legkésőbbi napnyugta",
  "astral.litShort": "Megvil.",
  "astral.longestDay": "Leghosszabb nap",
  "astral.lowestPoint": "Legalacsonyabb pont",
  "astral.maxAltitudeShort": "Max.",
  "astral.midday": "Dél",
  "astral.midnightSun": "Éjféli nap",
  "astral.midnightSunPeriod": "Éjféli nap",
  "astral.milestoneFootnotePolar": "Itt a nap az év {days, plural, one {# napján} other {# napján}} sem kel fel, sem nem nyugszik le, így a lista a szokásos napkelte- és napnyugta-szélsőértékek helyett azt mutatja, mikor történik ez.",
  "astral.milestoneFootnoteTemperate": "A legkorábbi naplemente és a legkésőbbi napkelte nem a legrövidebb napra esik — ezt a két dátumot az időegyenlet határozza meg, nem a napforduló.",
  "astral.moon": "Hold",
  "astral.moonAltitude": "Magasság",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Távolság",
  "astral.moonlessFor": "{duration} Hold nélkül",
  "astral.moonPhases": "Holdfázisok",
  "astral.moonrise": "Holdkelte",
  "astral.moonset": "Holdnyugta",
  "astral.moonUpAllNight": "A Hold egész éjjel a horizont felett van",
  "astral.moonWashesOutNight": "A Hold {rise} és {set} között a horizont felett van, és bevilágítja az egész éjszakát",
  "astral.morning": "Reggel",
  "astral.nauticalDawn": "Navigációs hajnal",
  "astral.nauticalDusk": "Navigációs alkony",
  "astral.nauticalSunPhase": "{sunPhase} tengeri",
  "astral.newMoon": "Újhold",
  "astral.nextDay": "+1 nap",
  "astral.nextProperlyDarkNight": "Következő igazán sötét éjszaka",
  "astral.nextRise": "következő holdkelte: {time}",
  "astral.nextRiseOn": "következő holdkelte: {day} {time}",
  "astral.nextSevenNights": "A következő hét éjszaka",
  "astral.noAstronomicalDarknessTonight": "Ma éjjel nincs csillagászati sötétség",
  "astral.noDarkNightAhead": "Nincs a következő két hétben",
  "astral.noon": "Dél",
  "astral.noSunriseToday": "Ma nincs napkelte",
  "astral.nowAtBearing": "most {altitude} · azimut {direction}",
  "astral.observing": "Észlelés",
  "astral.ofDaylightLeft": "napfény van hátra",
  "astral.overTheNextThreeWeeks": "a következő 3 hétben",
  "astral.percentLit": "{percent} megvilágítva",
  "astral.polarNight": "Sarki éjszaka",
  "astral.polarNightPeriod": "Sarki éjszaka",
  "astral.remainingDaylight": "Maradt nappali fény",
  "astral.rightNow": "Most",
  "astral.riseShort": "Kelte",
  "astral.setShort": "Nyugta",
  "astral.shortestDay": "Legrövidebb nap",
  "astral.solarNoon": "Valódi dél",
  "astral.solstice": "Napforduló",
  "astral.sunBelowHorizon": "A Nap {degrees}°-kal a horizont alatt",
  "astral.sunEvents": "Napesemények",
  "astral.sunNeverDarkEnough": "A Nap sosem süllyed 18°-kal a horizont alá",
  "astral.sunNeverSets": "A Nap nem nyugszik le",
  "astral.sunrise": "Napkelte",
  "astral.sunriseAndSunset": "Napkelte és napnyugta",
  "astral.sunriseAt": "Napkelte: {time}",
  "astral.sunset": "Napnyugta",
  "astral.sunsetAt": "Napnyugta: {time}",
  "astral.thisYearAtNorth": "Idén {degrees}° északi szélességen",
  "astral.thisYearAtSouth": "Idén {degrees}° déli szélességen",
  "astral.tonight": "Ma éjjel",
  "astral.totalDaylight": "Teljes nappali fény",
  "astral.twilightAllNight": "Egész éjjel szürkület — soha nem lesz teljesen sötét",
  "astral.upFor": "{duration} a horizont felett",
  "astral.usableLight": "Használható fény",
  "astral.vsAverage": "{percent} az átlaghoz képest",
  "astral.vsYesterday": "tegnaphoz képest",
  "astral.waningCrescent": "Fogyó holdsarló",
  "astral.waningGibbous": "Fogyó púpos hold",
  "astral.waxingCrescent": "Növekvő holdsarló",
  "astral.waxingGibbous": "Növekvő púpos hold",
  "astral.whereToLook": "Merre nézz",
  "astral.withoutTheMoon": "{duration} Hold nélkül",
  "auth.alreadyHaveAccount": "Már van fiókja?",
  "auth.authContainerTagline": "Személyes időjárás műszerfal. Csatlakoztassa állomásait, és valós idejű adatokat kapjon kéznél.",
  "auth.backToLogin": "Vissza a bejelentkezéshez",
  "auth.catchPhrase": "Az Időjárás Intelligencia Platform",
  "auth.checkYourEmail": "Ellenőrizze e-mailjét",
  "auth.continueWithApple": "Folytatás Apple-lel",
  "auth.continueWithFacebook": "Folytatás Facebook-kal",
  "auth.continueWithGoogle": "Folytatás Google-lel",
  "auth.email": "E-mail cím",
  "auth.emailRequiredLoginFacebook": "Email jóváhagyás szükséges a Facebook-bejelentkezéshez",
  "auth.emailVerification": "Email megerősítés",
  "auth.emailVerificationFailure": "Hiba történt az e-mail-cím ellenőrzése során.",
  "auth.emailVerificationSuccess": "E-mail-címét sikeresen ellenőriztük.",
  "auth.firstName": "Keresztnév",
  "auth.forgotPassword": "Elfelejtett jelszó",
  "auth.forgotPasswordSubtitle": "Adja meg e-mail címét, és küldünk egy linket a jelszó visszaállításához.",
  "auth.lastName": "Vezetéknév",
  "auth.login": "Bejelentkezés",
  "auth.loginSubtitle": "Üdvözöljük újra! Kérjük, adja meg adatait.",
  "auth.loginToSmartMixinDescription": "Adja meg SmartMixin hitelesítő adatait a fiók eléréséhez.",
  "auth.logout": "Kijelentkezés",
  "auth.logoutConfirmation": "Biztosan le akarja bontani a kapcsolatot?",
  "auth.noAccountYet": "Még nincs fiókja?",
  "auth.or": "vagy",
  "auth.password": "Jelszó",
  "auth.passwordAgain": "Jelszó megerősítése",
  "auth.passwordReset": "Jelszó visszaállítása",
  "auth.passwordResetSuccess": "Sikeres jelszó-visszaállítás.",
  "auth.register": "Regisztráció",
  "auth.registerDescription": "Hozzon létre ingyenes SmartMixin fiókot az időjárás-állomások csatlakoztatásához, időjárási adatok nyomon követéséhez és hatékony elemzési eszközök eléréséhez.",
  "auth.registerSubtitle": "Hozza létre fiókját a kezdéshez.",
  "auth.registerSuccess": "Sikeres regisztráció! Egy ellenőrző linket küldtünk Önnek a(z) {emailAddress} címen a további utasításokkal.",
  "auth.restorePassword": "Jelszó visszaállítása",
  "auth.restorePasswordSuccess": "Küldtünk egy linket a jelszó visszaállításához a(z) {emailAddress} címre a további utasításokkal.",
  "auth.sendReset": "Helyreállítási adatok küldése",
  "auth.signInWithApple": "",
  "auth.socialAccount": "vagy használja valamelyik közösségi profilját",
  "auth.welcome": "Üdvözöl a SmartMixin",
  "auth.welcomeBack": "Üdvözlünk!",
  "calendar.april": "Április",
  "calendar.august": "Augusztus",
  "calendar.dateFormat": "dátum formátum",
  "calendar.day": "Nap",
  "calendar.december": "December",
  "calendar.end": "Vége",
  "calendar.february": "Február",
  "calendar.hours": "óra",
  "calendar.hoursShort": "h",
  "calendar.january": "Január",
  "calendar.july": "Július",
  "calendar.june": "Június",
  "calendar.last24Hours": "elmúlt 24 óra",
  "calendar.last30Days": "elmúlt 30 nap",
  "calendar.last7Days": "elmúlt 7 nap",
  "calendar.march": "Március",
  "calendar.max": "Max",
  "calendar.may": "Május",
  "calendar.month": "Hónap",
  "calendar.months": "hónapok",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1 nap",
  "calendar.oneHour": "1 óra",
  "calendar.oneMonth": "1 hónap",
  "calendar.oneWeek": "1 hét",
  "calendar.previous24Hours": "Az előző 24 óra",
  "calendar.previous30Days": "Az előző 30 nap",
  "calendar.previous7Days": "Az előző 7 nap",
  "calendar.previousDay": "Tegnapi nappal",
  "calendar.previousMonth": "Előző hónappal",
  "calendar.previousWeek": "Előző héttel",
  "calendar.previousYear": "Tavalyi év",
  "calendar.sameDayLastYear": "Tavaly ugyanezzel a nappal",
  "calendar.sameMonthLastYear": "Tavaly ugyanezzel a hónappal",
  "calendar.selectADate": "Válasszon ki egy dátumot",
  "calendar.selectAggregation": "Megjelenített érték kiválasztása",
  "calendar.selectAMonth": "Válasszon egy hónapot",
  "calendar.selectAYear": "Válasszon egy évet",
  "calendar.selectGranularity": "Válasszon részletességet",
  "calendar.selectTimescale": "Időtáv választása",
  "calendar.september": "Szeptember",
  "calendar.sixHours": "6 óra",
  "calendar.start": "Kezdet",
  "calendar.thirtyMinutes": "30 perc",
  "calendar.threeHours": "3 óra",
  "calendar.use24HourFormat": "Használjon 24 órás formátumot",
  "calendar.week": "Hét",
  "calendar.year": "Év",
  "calendar.yesterday": "Tegnap",
  "common.accountDeleted": "Fiókját sikeresen töröltük.",
  "common.accountOnHold": "A fiókkapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "common.add": "Hozzáadás",
  "common.addAStation": "Állomás hozzáadása",
  "common.addToFavorites": "Add hozzá a kedvencekhez",
  "common.addYourOwnStation": "Adja hozzá az állomását",
  "common.afternoon": "Délután",
  "common.alreadyPremium": "Már van prémium előfizetése!",
  "common.alsoAvailableOn": "Elérhető még:",
  "common.altitude": "Magasság",
  "common.analysis": "Elemzés",
  "common.aroundMe": "Körülöttem",
  "common.articleCount": "{count} cikk",
  "common.articleNotFound": "A cikk nem található",
  "common.articleNotFoundDescription": "A keresett cikk nem létezik.",
  "common.average": "Átlag",
  "common.averageOverThePeriod": "Időszakos átlag",
  "common.away": "Távollét",
  "common.back": "Vissza",
  "common.backToHelpCenter": "Vissza a súgóközpontba",
  "common.backToHome": "Vissza a Főoldalra",
  "common.bad": "Rossz",
  "common.batteryLevel": "Akkumulátor töltöttsége",
  "common.bestValue": "Legjobb Érték",
  "common.billingDetailsAndroid": "A próbaverziós előfizetésért nem számítunk fel díjat, ha az ingyenes bevezető időszak lejárta előtt 24 órával lemondásra kerül. A próbaidőszak lejárta után is bármikor lemondható a SmartMixin-előfizetés a Google Play-fiók beállításaiban, egyébként pedig automatikusan megújításra kerül. Ezt legkésőbb 24 órával az előfizetési időszak vége előtt kell megtenni, hogy elkerüljük további díjak felszámítását. A kifizetéseket a Google Play-számládra terheljük a vásárlás visszaigazolásakor, ill. a megújítás során.",
  "common.billingDetailsIos": "A próbaverziós előfizetésért nem számítunk fel díjat, ha az ingyenes bevezető időszak lejárta előtt 24 órával lemondásra kerül. A próbaidőszak lejárta után is bármikor lemondható a SmartMixin-előfizetés az App Store-fiók beállításaiban, egyébként pedig automatikusan megújításra kerül. Ezt legkésőbb 24 órával az előfizetési időszak vége előtt kell megtenni, hogy elkerüljük további díjak felszámítását. A kifizetéseket az App Store-számládra terheljük a vásárlás visszaigazolásakor, ill. a megújítás során.",
  "common.boilerOn": "Kazán aktivitás",
  "common.browseByCategory": "Böngészés kategória szerint",
  "common.calendarView": "Naptár nézet",
  "common.cancel": "Mégse",
  "common.cannotBeEmpty": "Ez a mező nem lehet üres.",
  "common.cardDetails": "Kártya adatai",
  "common.categoryNotFound": "Kategória nem található",
  "common.categoryNotFoundDescription": "Ez a kategória nem létezik vagy nincsenek benne cikkek.",
  "common.charts": "Grafikonok",
  "common.chartView": "Diagram nézet",
  "common.clearRecentLocations": "Tisztítsa meg az összeset",
  "common.close": "Bezárás",
  "common.comparison": "Összehasonlítás",
  "common.contactMe": "Lépjen kapcsolatba velem",
  "common.currentDay": "Ma",
  "common.currentLocation": "Aktuális hely",
  "common.currentObservations": "Legújabb észlelések",
  "common.currentRainEvent": "Aktuális esőesemény",
  "common.currentRate": "Eső intenzitása",
  "common.currentWeatherConditions": "Aktuális feltételek",
  "common.customizeComparisonMetrics": "Összehasonlítási mutatók testreszabása",
  "common.customizeComparisonMetricsDescription": "Húzza az elemeket az összehasonlítási mutatók átrendezéséhez. Koppintson a szem ikonra a mutatók megjelenítéséhez vagy elrejtéséhez.",
  "common.customizeDashboard": "Testreszabás",
  "common.customizeDashboardDescription": "Húzza az elemeket az irányítópult átrendezéséhez. Koppintson a szem ikonra a szakaszok megjelenítéséhez vagy elrejtéséhez.",
  "common.customizedStationName": "Egyéni állomásnév",
  "common.dailyForecast": "Napi előrejelzés",
  "common.dashboard": "Irányítópult",
  "common.default": "Alapértelmezett",
  "common.defaultForecastModelChip": "Alapértelmezett · {name}",
  "common.delete": "Töröl",
  "common.deleteAccount": "Fiók törlése",
  "common.deleteAccountConfirmation": "Biztosan törölni szeretné fiókját? Ez a művelet visszafordíthatatlan.",
  "common.deleteAccountDescription": "Ez a művelet törli fiókját és minden adatát. Nincs visszaút.",
  "common.details": "Részletek",
  "common.durationHours": "{hours} ó",
  "common.durationHoursMinutes": "{hours} ó {minutes} p",
  "common.durationMinutes": "{minutes} p",
  "common.durationMinutesSeconds": "{minutes} p {seconds} mp",
  "common.durationSeconds": "{seconds} mp",
  "common.edit": "Szerkesztés",
  "common.editor": "Szerkesztő",
  "common.endTime": "Vége",
  "common.evening": "Este",
  "common.exitFullscreen": "Kilépés a teljes képernyőből",
  "common.exploreWeatherMap": "Időjárási Térkép Felfedezése",
  "common.favoriteLocations": "Kedvencek",
  "common.favoriteLocationsEmpty": "Legfeljebb 5 kedvenc helyet adhat hozzá.",
  "common.favoriteStations": "Kedvenc állomások",
  "common.feedbackHelpsImprove": "Visszajelzése segít nekünk javítani súgócikkeinket.",
  "common.feedbackReasonNotAnswer": "Nem válaszol a kérdésemre",
  "common.feedbackReasonOutdated": "Az információk elavultak",
  "common.feedbackReasonUnclear": "Az útmutató nem egyértelmű",
  "common.feedbackWhatWentWrong": "Mi volt a probléma?",
  "common.filterStationDescription": "Ne jelenjen meg megbízhatatlan mértékű állomás",
  "common.filterStations": "Szűrés állomások",
  "common.filterStationSourceDescription": "Válassza ki azokat az állomásszolgáltatókat, amelyeket meg szeretne jeleníteni a térképen",
  "common.findStationsNearYou": "Állomások keresése a közelben",
  "common.firmwareVersion": "Firmware verzió",
  "common.forecast": "Előrejelzés",
  "common.forecastAllModels": "Összes modell ({count})",
  "common.forecastComparisonDescription": "Könnyen összehasonlíthatja a különböző rendelkezésre álló időjárási modellek adatait",
  "common.forecastFollowingPreferences": "A beállításait követve",
  "common.forecastModelComparison": "Az időjárási modellek összehasonlítása",
  "common.forecastModelCoverage": "Lefedettség",
  "common.forecastModelDescription": "Leírás",
  "common.forecastModelDescription_AROME": "A Météo France konvekciót feloldó nagy felbontású modellje Nyugat-Európa felett 1,3 km felbontással. A legjobb a maga kategóriájában a franciaországi rövid távú előrejelzésekhez; háromóránként frissül.",
  "common.forecastModelDescription_ARPEGE_EU": "A Météo France ARPEGE modelljének európai fészke 10 km felbontással. Középtávú előrejelzések Európa felett, naponta négyszer frissülnek.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "A Météo France globális numerikus időjárási modellje 25 km felbontással, kb. 4 napig fut. Naponta négyszer frissül.",
  "common.forecastModelDescription_DMI_DINI": "A DMI HARMONIE DINI modellje: konvekciót felbontó modell Északnyugat-Európa felett — Dánia, a Benelux-államok, Írország, az Egyesült Királyság és Skandinávia —, 2 km felbontással, 60 óráig fut, naponta nyolcszor frissül. Módosított DMI nyílt adatokat tartalmaz (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Az Environment Canada Globális Determinisztikus Előrejelző Rendszere: globális középtávú modell 15 km felbontással, 10 napig fut, naponta kétszer frissül.",
  "common.forecastModelDescription_EC_HRDPS": "Az Environment Canada Nagyfelbontású Determinisztikus Előrejelző Rendszere: konvekciót felbontó modell Kanada és az Amerikai Egyesült Államok északi része felett 2,5 km felbontással, 48 óráig fut, naponta négyszer frissül.",
  "common.forecastModelDescription_EC_RDPS": "Az Environment Canada Regionális Determinisztikus Előrejelző Rendszere: középtávú modell Észak-Amerika felett 10 km felbontással, naponta négyszer frissül.",
  "common.forecastModelDescription_ECMWF_HRES": "Az Európai Középtávú Időjárás-előrejelző Központ nagy felbontású zászlóshajó-modellje (IFS), amelyet széles körben a világ vezető globális előrejelző rendszerének tartanak. Az egész bolygót lefedi 25 km-es felbontással 15 napig, naponta négyszer frissül. Módosított ECMWF nyílt adatokat tartalmaz (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "A NOAA zászlóshajó középtávú globális modellje. Az egész bolygót lefedi 25 km felbontással, akár 16 napig, naponta négyszer frissül.",
  "common.forecastModelDescription_HRRR_CONUS": "A NOAA High-Resolution Rapid Refresh modellje: konvekciót feloldó modell az Egyesült Államok kontinentális területe felett 3 km felbontással, óránként frissül. Leginkább nagyon rövid távú zivatar- és extrém időjárás-előrejelzésekhez ajánlott.",
  "common.forecastModelDescription_ICON": "A DWD globális ICON modellje 13 km-es felbontással, amely az egész bolygót lefedi 7,5 napig, naponta négyszer frissül. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "Az ItaliaMeteo ICON-2I modellje, az ARPAE-vel közösen üzemeltetve: konvekciót felbontó modell Olaszország felett, 2,2 km felbontással, 72 óráig fut, naponta kétszer frissül. ItaliaMeteo nyílt adatokat tartalmaz (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "A MeteoSwiss ICON-CH1-EPS kontrollfutása: konvekciót felbontó modell az Alpok felett, 1 km felbontással, 33 óráig fut, háromóránként frissül.",
  "common.forecastModelDescription_ICON_CH2": "A MeteoSwiss ICON-CH2-EPS kontrollfutása: konvekciót felbontó modell az Alpok felett — Svájc és a környező alpesi térség —, 2,1 km felbontással, 120 óráig fut, naponta négyszer frissül.",
  "common.forecastModelDescription_ICON_DE": "A DWD nagy felbontású konvekciót feloldó modellje Németország és a környező országok felett 2,2 km felbontással. Rövid távú előrejelzések naponta kétszer frissülnek. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "A DWD ICON modelljének európai fészke 7 km felbontással, Európát és az Észak-Atlanti-óceánt lefedi. Középtávú előrejelzések naponta négyszer frissülnek. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "A Norvég Meteorológiai Intézet nyílt időjárás-előrejelző szolgáltatása, amely a nagy felbontású északi modelleket az ECMWF adataival kombinálja, hogy akár 10 napos globális előrejelzéseket biztosítson.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME fészek a Francia Antillák felett (Guadeloupe, Martinique) 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME fészek Francia Guyana felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME fészek Új-Kaledónia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME fészek Francia Polinézia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME fészek Réunion és Mayotte felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_NAM_CONUS": "A NOAA North American Mesoscale modellfészke az Egyesült Államok kontinentális területe felett 5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "A NOAA North American Mesoscale modellje, amely az egész Észak-Amerikát lefedi 32 km felbontással. Naponta négyszer frissül.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "A SmartMixin zászlóshajó előrejelzése. Az Ön helyén minden órára kiválasztjuk a legjobb elérhető modellt — általában egy nagy felbontású regionális modellt ott, ahol létezik (AROME Franciaországban, ICON-D2 Németországban, HRRR az Egyesült Államokban, ARPEGE Europe a kontinens egészén…) és máshol egy globális modellre térünk vissza — majd kitöltjük a hiányosságokat a szomszédos forrásokból. Az eredmény egyetlen zökkenőmentes előrejelzés, amely 14 napig lefedi a világon bárhol, és automatikusan frissül, amikor bármelyik alapul szolgáló modellt frissítik.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "A Weatherflow saját globális előrejelzése, amely több numerikus időjárási modellt kever a Tempest meteorológiai állomások hálózatának megfigyeléseivel. 10 napos globális horizont.",
  "common.forecastModelDetailTitle": "Előrejelzési modell",
  "common.forecastModelScopeGlobal": "Globális",
  "common.forecastModelScopeGlobalDescription": "Ez a modell az egész bolygót lefedi.",
  "common.forecastModelScopeRegional": "Regionális",
  "common.forecastModelScopeRegionalDescription": "Ez a modell csak egy adott régiót fed le.",
  "common.forecastModelSpecifications": "Műszaki adatok",
  "common.forecastNoPinLocation": "Egyik kedvenc modell sem éri el ezt a helyet — a „mindenhol máshol” dönt.",
  "common.forecastNoPinStation": "Egyik kedvenc modell sem éri el ezt az állomást — a „mindenhol máshol” dönt.",
  "common.forecastNoPreferredModels": "Még nincs beállítva kedvenc modell.",
  "common.forecastOverrideElsewhere": "A beállításai mindenhol máshol érvényesek.",
  "common.forecastPickForLocation": "Vagy válasszon egyet ehhez a helyhez",
  "common.forecastPickForStation": "Vagy válasszon egyet ehhez az állomáshoz",
  "common.forecastPinWinsLocation": "{model} — az első kedvenc modellje, amely eléri ezt a helyet.",
  "common.forecastPinWinsStation": "{model} — az első kedvenc modellje, amely eléri ezt az állomást.",
  "common.forecastServedNowHere": "Jelenleg itt ez a {model}",
  "common.forecastSetForLocation": "Beállítva ehhez a helyhez",
  "common.forecastSetForStation": "Beállítva ehhez az állomáshoz",
  "common.forecastSettingsRowSub": "Kedvenc modellek, és ami mindenhol máshol érvényes",
  "common.forecastSheetTitle": "Előrejelzési modell",
  "common.forecastSources": "Előrejelzési források",
  "common.forecastStopUsingHere": "Ne használja itt",
  "common.forecastUseForLocation": "{model} használata ehhez a helyhez",
  "common.forecastUseForStation": "{model} használata ehhez az állomáshoz",
  "common.forecastUsePreferred": "Kedvenc modelljeim használata",
  "common.freeAccount": "Ingyenes számla",
  "common.freeSubscription": "Ingyenes előfizetés",
  "common.freeTrialForPeriod": "Ingyenes próbaidőszak {period} napig",
  "common.frequency": "Frekvencia",
  "common.full": "Teljes",
  "common.fullscreen": "Teljes képernyő",
  "common.getStartedFree": "Ingyenes Indulás",
  "common.getUnlimitedAccess": "Korlátlan hozzáférés:",
  "common.good": "Jó",
  "common.hail": "Jégeső",
  "common.help": "Súgó",
  "common.helpCategoryAccount": "Fiók",
  "common.helpCategoryBilling": "Számlázás",
  "common.helpCategoryForecast": "Előrejelzések",
  "common.helpCategoryGettingStarted": "Első lépések",
  "common.helpCategoryProviders": "Szolgáltatók",
  "common.helpCategoryStations": "Állomások",
  "common.helpCategoryTroubleshooting": "Hibaelhárítás",
  "common.helpCenter": "Súgóközpont",
  "common.helpCenterDescription": "Találjon válaszokat a gyakori kérdésekre, és ismerje meg, hogyan hozhatja ki a legtöbbet a SmartMixinből.",
  "common.hg": "Fagyvédelem",
  "common.hidden": "Rejtett",
  "common.hiddenSensors": "Rejtett érzékelők",
  "common.hiddenStations": "Rejtett állomások",
  "common.hiddenStationsDescription": "Egy állomás elrejtését a mellette lévő szem ikonra koppintva szüntetheti meg.",
  "common.high": "Magas",
  "common.home": "Otthon",
  "common.homeConnectService": "Van időjárás-állomása? Csatlakoztassa a szolgáltatását",
  "common.homeInformation": "Otthoni információk",
  "common.homeIntroduction": "Kapcsolódjon össze külső fiókjaival a SmartMixin szolgáltatásainak használatához.",
  "common.homeName": "Otthoni név",
  "common.homeSubtitle": "Az időjárásod, minden egy helyen",
  "common.horizon": "Horizon",
  "common.horizonValue": "legfeljebb {value} óra",
  "common.hour": "Óra",
  "common.iDontKnowYet": "Még nem tudom",
  "common.indoor": "Beltér",
  "common.lastRainEvent": "Utolsó esős esemény",
  "common.lastUpdate": "Utolsó frissítés",
  "common.legendHeavy": "Erős",
  "common.legendLight": "Gyenge",
  "common.legendLightningHelp": "A szín az egyes villámok korát mutatja az elmúlt {minutes} percben — a legújabbak fehérrel, a legrégebbiek sötétvörössel.",
  "common.legendNewest": "Legújabb",
  "common.legendOldest": "Legrégebbi",
  "common.legendStationsHelp": "A jelölő színe a kiválasztott mérőszám értékét tükrözi.",
  "common.lightningDataAttribution": "Villámadatok: Blitzortung.org",
  "common.lightningStrikes": "Villámcsapások",
  "common.lightningStrikesDescription": "Villámcsapások megjelenítése valós időben a térképen",
  "common.linkToSection": "Hivatkozás erre a szakaszra",
  "common.loading": "Betöltés",
  "common.location": "Hely",
  "common.locationAddedToFavorites": "Helyszín hozzáadva a kedvencekhez",
  "common.locationNotGranted": "A helymeghatározási engedély nem adható meg. Kérjük, hagyja, hogy az eszközbeállításokban hozzáférhessen a tartózkodási helyhez.",
  "common.locationRemovedFromFavorites": "Helyet eltávolítva a kedvencektől",
  "common.locations": "Helyek",
  "common.low": "Alacsony",
  "common.manage": "Kezelés",
  "common.manageAccount": "Fiók kezelése",
  "common.manageMySubscription": "Előfizetés megtekintése",
  "common.manageSensors": "Érzékelők kezelése",
  "common.manageSensorsDescription": "Húzza az elemeket az érzékelők átrendezéséhez. Koppintson a szem ikonra az érzékelők megjelenítéséhez vagy elrejtéséhez. Koppintson egy névre az átnevezéshez.",
  "common.manualBoost": "Manuális szabályzás",
  "common.manualSetpointUntil": "Manuális alapjel egészen",
  "common.mapLayers": "Térképrétegek",
  "common.mapLegend": "Térkép jelmagyarázat",
  "common.maxFavoriteLocationsReached": "Csak 5 kedvenc helye lehet. Távolítsa el az egyiket a másik hozzáadásához.",
  "common.maximum": "Maximum",
  "common.maxOverThePeriod": "Időszakos maximum",
  "common.measureToDisplay": "Megjelenítendő mérés",
  "common.medium": "Közepes",
  "common.meshSize": "Rács mérete",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} perc olvasás",
  "common.modifyFavoriteStations": "Módosítsa a kedvenc állomásait",
  "common.modifyFavoriteStationsDescription": "Átrendezheti kedvenc állomásait azáltal, hogy húzza őket. A listáról is eltávolíthatja őket.",
  "common.moduleType": "Modultípus",
  "common.monthTotal": "Ebben a hónapban",
  "common.more": "Egyéb",
  "common.moreInformation": "További információ",
  "common.morning": "Reggel",
  "common.myLocation": "Saját hely",
  "common.nearbyWeatherStations": "Közeli időjárási állomások",
  "common.next": "Következő",
  "common.nextHours": "Órák jönnek",
  "common.night": "Éjszaka",
  "common.no": "Nem",
  "common.noAccountNeeded": "Nincs szükség fiókra",
  "common.noDataForThisPeriod": "Nincs adat a választott időszakban",
  "common.noLocationsFound": "Nem található hely",
  "common.noNetatmoWeatherStationYet": "Jelenleg nem kapcsolódik egyetlen időjárás állomáshoz sem.",
  "common.noOutdoorModule": "Ehhez az állomáshoz nincs működő kültéri modul.",
  "common.noSearchResults": "Nincs a keresésnek megfelelő cikk",
  "common.noStationsFound": "Nem található állomás",
  "common.noThermostatYet": "Jelenleg nem kapcsolódik egyetlen termosztáthoz sem.",
  "common.notNow": "Most nem",
  "common.notPurchasedYet": "Úgy tűnik, még nem vásároltad meg ezt a funckiót.",
  "common.now": "Most",
  "common.noWeatherStation": "Nincs meteorológiai állomás",
  "common.noWeatherStationYet": "Jelenleg nem kapcsolódik egyetlen időjárás állomáshoz sem.",
  "common.numberOfActiveWarnings": "{warning_count} aktív időjárási figyelmeztetések",
  "common.onThisPage": "Ezen az oldalon",
  "common.openSettings": "Nyissa meg a beállításokat",
  "common.orChooseMonthly": "Vagy válassz havi előfizetést:",
  "common.outdatedModule": "Ennek az egységnek az adatai elavultak.",
  "common.outdoor": "Kültér",
  "common.outdoorTemperature": "Kültéri hőmérséklet",
  "common.pageNotFound": "Az Oldal Nem Található",
  "common.pageNotFoundDescription": "A keresett oldal nem létezik vagy áthelyezték.",
  "common.passwordUpdated": "A jelszó sikeresen frissítve.",
  "common.personalWeatherIntelligence": "Az Ön Személyes Időjárás Intelligenciája",
  "common.platformMobileApp": "Mobilalkalmazás",
  "common.platformMobileOnly": "Csak a mobilalkalmazásban",
  "common.platformWebApp": "Webalkalmazás",
  "common.platformWebOnly": "Csak a webalkalmazásban",
  "common.popularArticles": "Népszerű cikkek",
  "common.premiumAccount": "Prémium fiók",
  "common.premiumDescription": "Prémium előfizetéssel lehetővé válik időjárási adatai részletes elemezése, grafikonos összehasonlítások készítése, regionális szolgáltatók kiválasztása az előrejelzéshez, stb.",
  "common.premiumFeatureAlerts": "Időjárási Riasztások",
  "common.premiumFeatureAnalysis": "Fejlett Időjárás Elemzés",
  "common.premiumFeatureCharts": "Grafikon Összehasonlítások",
  "common.premiumFeatureExport": "Adatexportálás",
  "common.premiumFeatureForecast": "Regionális Előrejelzési Modellek",
  "common.premiumFeatureNotification": "Állapotsáv Widget",
  "common.premiumFeatureTitle": "Prémium Funkció",
  "common.premiumFeatureWidgets": "Kezdőképernyő widgetek",
  "common.pressureSummary": "A nyomás szintézise",
  "common.previous": "Előző",
  "common.previousHours": "Korábbi órák",
  "common.profileUpdated": "Adataid sikeresen frissítve.",
  "common.purchasedNetatmoPro": "Ön korábban megvásárolta a Netatmo Pro ({date}). Iratkozzon fel az alábbi ajánlatok egyikére, hogy hozzáférjen az alkalmazás összes prémium funkciójához.",
  "common.radarDataAttribution": "Radaradatok: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Csapadék",
  "common.rainEvents": "Esős",
  "common.rainfallMeasurement": "Csapadékmérés",
  "common.rainRadar": "esőradar",
  "common.rainRadarDescription": "Jelenítse meg az esőradar fedvényét a térképen",
  "common.rainSummary": "A csapadék összegzése",
  "common.range": "Tartomány",
  "common.recentLocations": "Legújabb",
  "common.recentLocationsEmpty": "A közelmúlt története üres.",
  "common.recentStations": "Legutóbbi állomások",
  "common.relatedArticles": "Kapcsolódó cikkek",
  "common.relay": "Relé",
  "common.removeFromFavorites": "Törlés a kedvencek közül",
  "common.renameSensors": "Érzékelők átnevezése",
  "common.resetZoom": "Nagyítás visszaállítása",
  "common.restorePurchase": "Licensz visszaállítása",
  "common.room": "Szoba",
  "common.rooms": "Szobák",
  "common.savingsPercent": "Megtakarítás {percent}%",
  "common.searchArticles": "Cikkek keresése...",
  "common.searchForALocation": "Hely keresése...",
  "common.searchForLocation": "Találj egy helyet",
  "common.searchForWeatherStation": "Keressen egy meteorológiai állomást",
  "common.searchResults": "Keresési eredmények",
  "common.searchResultsEmpty": "Nincs eredmény.",
  "common.searchResultsFound": "{count, plural, one {# találat} other {# találat}}",
  "common.searchStationsDescription": "Adjon meg egy várost, címet vagy helynevet a közeli időjárás-állomások megtalálásához.",
  "common.searchStationsHint": "Használja a fenti keresősávot, hogy felfedezze az időjárás-állomásokat a világ bármely pontján.",
  "common.selectStationForComparison": "Válassza ki az állomást az összehasonlításhoz",
  "common.selectWeatherForecastProvider": "Időjárási adatszolgáltató választása",
  "common.serialNumber": "Sorozatszám",
  "common.share": "Ossza meg",
  "common.shareOutdoorMeasures": "Ossza meg kültéri méréseit",
  "common.shareOutdoorMeasuresDescription": "Vegyen részt a SmartMixin közösségben külső adatainak megosztásával. A beltéri modulok adatai soha nem lesznek megosztva.",
  "common.shareYourWeather": "Ossza meg időjárását",
  "common.signalStrength": "Jelerősség",
  "common.skip": "Kihagyás",
  "common.smartThermostat": "Okos termosztát",
  "common.smartValve": "Okos radiátorszelep",
  "common.snow": "Hó",
  "common.start": "Indul",
  "common.startFreeTrial": "Ingyenes Próba Indítása",
  "common.startTime": "Kezdet",
  "common.station": "állomás",
  "common.stationAddedToFavorites": "Az állomás hozzáadva a kedvencekhez",
  "common.stationComparison": "Állomások összehasonlítása",
  "common.stationComparisonDescription": "Lehetővé teszi a korábbi időjárási adatok összehasonlítását egy másik állomás adataival.",
  "common.stationInformation": "Állomás adatok",
  "common.stationName": "Állomás neve",
  "common.stationObservationsDescription": "Megjeleníti az időjárási állomások legfrissebb megfigyelését",
  "common.stationRemovedFromFavorites": "Az állomás eltávolítva a kedvencek közül",
  "common.stations": "állomások",
  "common.stationsNear": "Állomások a közelben",
  "common.stationType": "állomás típusa",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Elavult",
  "common.statusSyncing": "Szinkronizálás",
  "common.stillNeedHelp": "További segítségre van szüksége?",
  "common.stillNeedHelpDescription": "Ha ez a cikk nem válaszolta meg a kérdését, szívesen segítek közvetlenül.",
  "common.subscribeNow": "Feliratkozás most - próbaidő nélkül",
  "common.sumOverThePeriod": "Az időszakban összesen",
  "common.switchToPremium": "SmartMixin Premium előfizetés",
  "common.temperatureShort": "Hőm.",
  "common.temperatureSummary": "Hőmérséklet összefoglaló",
  "common.thankYouForFeedback": "Köszönjük a visszajelzést!",
  "common.thenPrice": "majd {price}",
  "common.timeSelection": "Idő kiválasztása",
  "common.timezone": "Időzóna",
  "common.totalDuration": "Teljes időtartam",
  "common.tryAnotherLocation": "Nem találtunk időjárás-állomásokat e hely közelében. Próbáljon meg egy másik területen keresni.",
  "common.unknown": "Ismeretlen",
  "common.untilChanged": "Amíg nem változott",
  "common.untilTime": "Egészen {time}",
  "common.updateAvailable": "Frissítés érhető el",
  "common.updateAvailableOpenAppStore": "Koppintson az App Store megnyitásához",
  "common.updateAvailableOpenGooglePlay": "Koppintson a Google Play megnyitásához",
  "common.updateAvailableVersion": "Frissítés érhető el: v{version}",
  "common.upgrade": "Frissítés",
  "common.upgradeRequiredAndroid": "Az alkalmazás frissítésére van szükség. Látogasson el a Google Playre a frissítéshez.",
  "common.upgradeRequiredIos": "Az alkalmazás frissítésére van szükség. Lépjen be az alkalmazásboltba.",
  "common.validate": "Érvényesítés",
  "common.validEmail": "Érvényes e-mail cím szükséges.",
  "common.very_low": "Nagyon alacsony",
  "common.viewAsList": "Lista",
  "common.viewAsPeriods": "Napszakok",
  "common.visitNetatmoWebsite": "Netatmo weboldalának felkeresése",
  "common.wasArticleHelpful": "Hasznos volt ez a cikk?",
  "common.weatherCondition": "Időjárási állapot",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "Az NC Rain egy további adatforrás, amelyet a Nearcast Technology által hajtott Tempest Weather System biztosít. Az NC Rain adatok a Tempest körüli átlagos csapadékmennyiség becslése a környék szintjén",
  "common.weatherForecastModels": "Időjárás-előrejelzési modellek",
  "common.weatherIntelligencePlatform": "Az Időjárás Intelligencia Platform",
  "common.weatherMap": "Meteorológiai térkép",
  "common.weatherMapMetaDescription": "A SmartMixin interaktív időjárási és radaros térképeket kínál a világ minden tájáról.",
  "common.weatherObservations": "Időjárási megfigyelések",
  "common.weatherStation": "Meteorológiai állomás",
  "common.weatherStations": "Meteorológiai állomások",
  "common.welcome": "Üdvözöl a SmartMixin!",
  "common.whenBackHome": "Mikor fog hazaérni?",
  "common.wifiStrength": "WiFi jelerősség",
  "common.wind": "Szél",
  "common.windMeasurement": "Szélmérés",
  "common.windSpeed": "Szélsebesség",
  "common.windSummary": "A szél szintézise",
  "common.yearToDate": "Idén",
  "common.yes": "Igen",
  "common.zoomImage": "Kép nagyítása",
  "forecastMaps.addColor": "Szín hozzáadása",
  "forecastMaps.addLayer": "Réteg hozzáadása",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Vissza a térképekhez",
  "forecastMaps.browseMaps": "Térképek böngészése",
  "forecastMaps.build": "Generálás",
  "forecastMaps.buildCompleted": "Generálás kész",
  "forecastMaps.builderMetaDescription": "Állítson össze egyéni előrejelzési térképeket az időjárási modellek rétegeiből.",
  "forecastMaps.builderTitle": "Térképszerkesztő",
  "forecastMaps.buildFailed": "A generálás nem sikerült. Próbálja újra.",
  "forecastMaps.buildNotPossible": "Ez a térkép még nem generálható — nincs elérhető előrejelzési adat.",
  "forecastMaps.buildProgress": "Renderelés… {completed}/{total} lépés",
  "forecastMaps.buildStarting": "Generálás indítása…",
  "forecastMaps.byModel": "Modell szerint",
  "forecastMaps.byZone": "Zóna szerint",
  "forecastMaps.colormap": "Színskála",
  "forecastMaps.colormapCustom": "Egyéni színek",
  "forecastMaps.colormapGroupDomain": "Időjárási sablonok",
  "forecastMaps.colormapGroupMatplotlib": "Tudományos sablonok",
  "forecastMaps.colorScale": "Színskála",
  "forecastMaps.comingSoon": "Ez a nézet hamarosan elérhető lesz.",
  "forecastMaps.contourLevels": "Kontúrszintek",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Franciaország",
  "forecastMaps.countryGermany": "Németország",
  "forecastMaps.countryItaly": "Olaszország",
  "forecastMaps.countryScandinavia": "Skandinávia",
  "forecastMaps.countrySpain": "Spanyolország",
  "forecastMaps.countrySwitzerland": "Svájc",
  "forecastMaps.countryUnitedStates": "Egyesült Államok",
  "forecastMaps.customColormapMinColors": "Az egyéni színskálához legalább két szín szükséges",
  "forecastMaps.customExtent": "Egyéni kivágat",
  "forecastMaps.deleteMap": "Térkép törlése",
  "forecastMaps.deleteMapBody": "A(z) „{name}” és a hozzá tartozó renderelések véglegesen törlődnek.",
  "forecastMaps.deleteMapTitle": "Törli ezt a térképet?",
  "forecastMaps.displayName": "Megjelenített név",
  "forecastMaps.downloadMp4": "MP4 letöltése",
  "forecastMaps.downscaling": "Szélzászló-ritkítási tényező",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Terület rajzolása",
  "forecastMaps.east": "Kelet",
  "forecastMaps.editMap": "Térkép szerkesztése",
  "forecastMaps.exportBuilding": "Videó előkészítése…",
  "forecastMaps.exportError": "A videó exportálása nem sikerült. Próbálja újra.",
  "forecastMaps.exportMp4": "Exportálás MP4-be",
  "forecastMaps.exportNotReady": "A videó még nem készült el. Próbálja újra később.",
  "forecastMaps.extentDrawHint": "Húzással rajzolja meg a területet a térképen",
  "forecastMaps.extentInvalid": "A nyugatnak kisebbnek kell lennie a keletnél, a délnek az északnál",
  "forecastMaps.extentPanZoomHint": "Mozgassa és nagyítsa a térképet, amíg a terület ki nem tölti a keretet",
  "forecastMaps.flipbookView": "Animáció",
  "forecastMaps.forecastModel": "Előrejelzési modell",
  "forecastMaps.forkAndEdit": "Másolás és szerkesztés",
  "forecastMaps.height": "Magasság (hüvelyk)",
  "forecastMaps.hourOffset": "+{hour} ó",
  "forecastMaps.invalidHexColor": "Érvénytelen szín — használjon #RRGGBB formátumot",
  "forecastMaps.layers": "Rétegek",
  "forecastMaps.layerTypeBarbs": "Szélzászlók",
  "forecastMaps.layerTypeContour": "Kontúrvonalak",
  "forecastMaps.layerTypeFilledContour": "Kitöltött kontúrok",
  "forecastMaps.layerTypeMagnitude": "Nagyság",
  "forecastMaps.layerTypeRaster": "Raszter",
  "forecastMaps.layerTypeVectorField": "Vektormező",
  "forecastMaps.leave": "Kilépés",
  "forecastMaps.levelsCount": "Darabszám",
  "forecastMaps.levelsInvalid": "Érvénytelen kontúrszintek",
  "forecastMaps.levelsModeArange": "Rögzített lépésköz",
  "forecastMaps.levelsModeExplicit": "Explicit értékek",
  "forecastMaps.levelsModeLinspace": "Egyenletes eloszlás (darabszám)",
  "forecastMaps.levelsStep": "Lépésköz",
  "forecastMaps.levelsValues": "Értékek",
  "forecastMaps.levelsValuesHint": "Vesszővel elválasztva, növekvő sorrendben",
  "forecastMaps.localTimeHint": "A helyi idő szerint megjelenítve",
  "forecastMaps.map": "Térkép",
  "forecastMaps.mapDescription": "Leírás",
  "forecastMaps.mapName": "Térkép neve",
  "forecastMaps.mapNameRequired": "Adjon meg egy nevet",
  "forecastMaps.mapSettings": "Térképbeállítások",
  "forecastMaps.mapView": "Interaktív térkép",
  "forecastMaps.maxLayersReached": "Ez a térkép elérte a maximális {max} réteget.",
  "forecastMaps.maxValue": "Maximális érték",
  "forecastMaps.memoryBudgetExceeded": "A felbontás túllépi a renderelési keretet — csökkentse a DPI-t vagy a magasságot",
  "forecastMaps.memoryBudgetUsage": "Renderelési keret: {percent}%",
  "forecastMaps.metaDescription": "Animált előrejelzési térképek az időjárási modellek futásaiból.",
  "forecastMaps.metric": "Mérőszám",
  "forecastMaps.metricRequired": "Válasszon mérőszámot",
  "forecastMaps.metricUnavailable": "Ehhez a modellhez nem érhető el",
  "forecastMaps.minBelowMax": "A minimumnak kisebbnek kell lennie a maximumnál",
  "forecastMaps.minMaxRequired": "Ehhez a rétegtípushoz minimum- és maximumérték szükséges",
  "forecastMaps.minValue": "Minimális érték",
  "forecastMaps.modelNoRun": "Még nincs befejezett futás",
  "forecastMaps.moveLayerDown": "Mozgatás lefelé",
  "forecastMaps.moveLayerUp": "Mozgatás felfelé",
  "forecastMaps.myMaps": "Saját térképeim",
  "forecastMaps.nanClipToMin": "Levágás a minimumra",
  "forecastMaps.nanMask": "Maszkolás",
  "forecastMaps.nanPolicy": "Hiányzó adatok",
  "forecastMaps.nanSkip": "Kihagyás",
  "forecastMaps.newMap": "Új térkép",
  "forecastMaps.noCompletedRun": "Ez a térkép még nem készült el. Nézzen vissza hamarosan.",
  "forecastMaps.noLayers": "Még nincs réteg. Adjon hozzá egy réteget a kezdéshez.",
  "forecastMaps.noMapsAvailable": "Még nincsenek elérhető előrejelzési térképek.",
  "forecastMaps.north": "Észak",
  "forecastMaps.opacity": "Átlátszatlanság",
  "forecastMaps.overlayLegend": "Jelmagyarázat",
  "forecastMaps.pause": "Szünet",
  "forecastMaps.play": "Lejátszás",
  "forecastMaps.pointValueError": "Nem sikerült betölteni az előrejelzést ehhez a ponthoz.",
  "forecastMaps.pointValueLoading": "Előrejelzés betöltése…",
  "forecastMaps.pointValueUnavailable": "Nincs adat ehhez az időponthoz.",
  "forecastMaps.presets": "Sablonok",
  "forecastMaps.preview": "Előnézet",
  "forecastMaps.previewEmptyHint": "Állítson be legalább egy érvényes réteget az előnézet rendereléséhez.",
  "forecastMaps.previewFailed": "Az előnézet nem sikerült",
  "forecastMaps.previewHour": "Előrejelzési óra",
  "forecastMaps.previewRendering": "Előnézet renderelése…",
  "forecastMaps.projection": "Vetület",
  "forecastMaps.projectionLambertConformal": "Lambert-féle szögtartó",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Sztereografikus",
  "forecastMaps.regionEurope": "Európa",
  "forecastMaps.regionNorthAmerica": "Észak-Amerika",
  "forecastMaps.removeColor": "Szín eltávolítása",
  "forecastMaps.removeLayer": "Réteg eltávolítása",
  "forecastMaps.retry": "Újra",
  "forecastMaps.run": "Futás: {run}",
  "forecastMaps.save": "Mentés",
  "forecastMaps.selectExtentOnMap": "Terület kijelölése a térképen",
  "forecastMaps.south": "Dél",
  "forecastMaps.title": "Előrejelzési térképek",
  "forecastMaps.uMetric": "U-komponens",
  "forecastMaps.unitConversion": "Mértékegység-átváltás",
  "forecastMaps.unitNone": "Nincs",
  "forecastMaps.unsavedChangesBody": "Nem mentett módosításai vannak. Kilép és elveti őket?",
  "forecastMaps.unsavedChangesTitle": "Nem mentett módosítások",
  "forecastMaps.useCurrentView": "Jelenlegi nézet használata",
  "forecastMaps.useModelDomain": "Ki: a modell teljes tartománya lesz használva",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Az U és V mérőszámoknak különbözniük kell",
  "forecastMaps.validTime": "Érvényes: {time}",
  "forecastMaps.valueBetween": "{min} és {max} között kell lennie",
  "forecastMaps.variable": "Változó",
  "forecastMaps.viewMap": "Térkép megtekintése",
  "forecastMaps.vMetric": "V-komponens",
  "forecastMaps.west": "Nyugat",
  "forecastMaps.windAnimation": "Szélanimáció",
  "intro.locationDescription": "Engedélyezd a helymeghatározást, hogy pontos, pontosan a területedre szabott időjárás‑előrejelzéseket kapj — nincs több általános előrejelzés.",
  "intro.locationTitle": "Előrejelzések neked szabva",
  "intro.notificationDescription": "Kapcsold be az értesítéseket, hogy időben figyelmeztetéseket kapj a számodra fontos időjárás‑változásokról — eső, hó vagy extrém körülmények, amikor csak kell.",
  "intro.notificationsTitle": "Ne maradj le egy időjárás‑változásról sem",
  "intro.readyDescription": "Élvezd a pontos előrejelzéseket, valós idejű időjárás‑információkat és állomásadatokat a világ minden tájáról — egyetlen erőteljes alkalmazásban.",
  "intro.readyTitle": "Készen állsz!",
  "intro.welcomeDescription": "Hyperlokális előrejelzések az iparág legjobb meteorológiai ügynökségeitől — plusz hozzáférés több mint 40 000 időjárási állomáshoz világszerte, hogy lásd a tényleges körülményeket, jelenleg és múltban.",
  "intro.welcomeTitle": "Időjárás újragondolva",
  "landing.alerts": "Figyelmeztetések",
  "landing.alertsDescription": "Hozzon létre saját figyelmeztetéseket, és azonnal értesítést kapjon, amint aktiválódnak.",
  "landing.featureAlertsDescription": "Állítson be egyéni riasztásokat az Ön által fontosnak tartott feltételekre—hőmérséklet, szél, csapadék és több.",
  "landing.featureAlertsTitle": "Intelligens riasztások",
  "landing.featureAnalyticsDescription": "Merüljön el az adataiban interaktív diagramokkal, egymás melletti összehasonlításokkal és trendanalízissel az alapvető metrikákon túl.",
  "landing.featureAnalyticsTitle": "Hatékony elemzések",
  "landing.featureExportDescription": "Töltse le az adatait CSV formátumban Excel elemzéshez, más rendszerekkel való integrációhoz vagy biztonsági mentéshez.",
  "landing.featureExportTitle": "Exportálás bárhová",
  "landing.featureForecastDescription": "Hasonlítsa össze több mint 10 időjárási modell előrejelzéseit, beleértve a GFS, ECMWF, ICON és további modelleket, hogy lássa, melyik működik a legjobban az Ön helyszínén.",
  "landing.featureForecastTitle": "Előrejelzés összehasonlítás",
  "landing.featureHistoryDescription": "Hozzáférés történelmi adatokhoz óránkénti, napi és havi skálán. Export CSV formátumba kutatáshoz vagy személyes archívumba.",
  "landing.featureHistoryTitle": "Gazdag előzmények",
  "landing.featureMultiBrandDescription": "Csatlakoztass állomásokat Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow és más márkáktól—minden egy irányítópulton.",
  "landing.featureMultiBrandTitle": "Több márka támogatás",
  "landing.featuresSubtitle": "Időjárás rajongóknak tervezve, akik többet várnak el egy egyszerű időjárás-állomás alkalmazásnál.",
  "landing.featuresTitle": "Minden, ami az időjárás elemzéséhez kell",
  "landing.finalCtaButton": "Ingyenes fiók létrehozása",
  "landing.finalCtaSubtitle": "Csatlakozzon több ezer időjárás rajongóhoz, akik a SmartMixinre bízzák időjárási adataikat.",
  "landing.finalCtaTitle": "Készen áll az időjárás élmény fejlesztésére?",
  "landing.forecastDescription": "Nézze meg a legjobb időjárás-előrejelzési modelleket, és hasonlítsa össze őket, hogy saját elképzelést kapjon arról, milyen lesz az időjárás.",
  "landing.forecasts": "Előrejelzések",
  "landing.heroCta": "Ingyenes kezdés",
  "landing.heroDescription": "Kombinálja több időjárás-állomás adatait bármely márkától, hasonlítsa össze az előrejelzési modelleket és elemezze az adatait részletes diagramokkal és exportálással.",
  "landing.heroSecondaryCta": "Funkciók megtekintése",
  "landing.heroTagline": "Minden időjárási adat. Egy platform.",
  "landing.heroTitle": "Minden időjárási adat. Egy platform.",
  "landing.pricingFeatureAdvancedMetrics": "Haladó mérőszámok",
  "landing.pricingFeatureAlerts": "Egyéni riasztások",
  "landing.pricingFeatureExport": "Adatexport (CSV)",
  "landing.pricingFeatureForecastComparison": "Előrejelzés-összehasonlítás",
  "landing.pricingFeatureForecasts": "Előrejelzési modellek",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "Minden modell (10+)",
  "landing.pricingFeatureReports": "Elemzések és jelentések",
  "landing.pricingFeatureStationComparison": "Állomás-összehasonlítás",
  "landing.pricingFeatureWidgets": "Kezdőképernyő widgetek",
  "landing.pricingFeatureYearOverYear": "Éves összehasonlító elemzés",
  "landing.pricingFree": "Ingyenes",
  "landing.pricingFreeCta": "Kezdés",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Legnépszerűbb",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Kezdje el",
  "landing.pricingPremiumDescription": "1,99 €/hónaptól — fizessen elő weben, App Store-ban vagy Google Playen",
  "landing.pricingSubtitle": "Kezdje ingyenesen, frissítsen, amikor többre van szüksége.",
  "landing.pricingTitle": "Egyszerű, átlátható árazás",
  "landing.smartMixinDescription": "A SmartMixin egy olyan alkalmazás, amely hozzáférést biztosít időjárási állomásához és több mint 40 ezer további állomáshoz világszerte. Segít meglátni és megérteni az időjárási adatokat.",
  "landing.statBrands": "Támogatott márkák",
  "landing.statForecasts": "Előrejelzési modellek",
  "landing.statStations": "Időjárás-állomások",
  "landing.supportedDevices": "Támogatott eszközök",
  "landing.supportedDevicesDescription": "A Meteorológiai Világszervezet állomásai mellett a SmartMixin egyre több időjárási állomás márkát támogat.",
  "landing.supportedDevicesNote": "Valamint több mint 40 000 nyilvános állomás a Meteorológiai Világszervezettől",
  "landing.supportedDevicesSubtitle": "Csatlakoztasson időjárás-állomásokat vezető márkáktól és tekintse meg az összes adatot egy helyen.",
  "landing.supportedDevicesTitle": "Működik az állomásaiddal",
  "landing.thermostatDescription": "Csatlakoztassa Netatmo termosztátját a fűtési minták és a kültéri körülmények összehasonlításához.",
  "landing.thermostatManufacturers": "A termosztátgyártók szintén támogatják a fűtés és a kültéri feltételek közötti összefüggést.",
  "landing.thermostatTitle": "Okosotthon-integráció",
  "landing.weatherAnalysis": "Időjárás elemzése",
  "landing.weatherAnalysisDescription": "A SmartMix számos adatvizualizációt tartalmaz, amelyek lehetővé teszik az időjárási adatok elemzését.",
  "landing.weatherAssistant": "Az Ön időjárási asszisztense",
  "landing.weatherAssistantDescription": "Akár aktuális, történelmi vagy előrejelzett időjárási viszonyok érdekelnek, a SmartMixin számos betekintést nyújt, amikor csak szüksége van rájuk.",
  "landing.weatherForecastModels": "Időjárás-előrejelzési modellek",
  "landing.weatherForecastModelsDescription": "A SmartMixin hozzáférést biztosít a legpontosabb időjárás-előrejelzési modellekhez. Könnyedén összehasonlíthatja előrejelzéseiket, és elkészítheti saját elképzeléseit.",
  "landing.weatherMap": "Időjárási térkép",
  "landing.weatherMapDescription": "Böngésszen a térképen, és képzelje el, milyen az időjárás bárhol a világon.",
  "network.cancelError": "Kérés visszavonva",
  "network.connectionError": "Szerver nem elérhető",
  "network.networkError": "Hálózat nem elérhető",
  "network.serverError": "Szerverhiba...",
  "network.timeoutError": "Kapcsolat időtúllépés",
  "network.unknownError": "Ismeretlen hiba",
  "providerHints.ambientWeatherApiKey": "Az ambientweather.net fiókbeállításaiban hozható létre.",
  "providerHints.davisApiSecret": "Csak egyszer látható a V2 API-kulcs létrehozásakor — őrizze meg biztonságosan.",
  "providerHints.davisV2ApiKey": "A weatherlink.com V2 API-kulcsok oldaláról.",
  "providerHints.ecowittApi": "Az Ecowitt fiók API-oldaláról.",
  "providerHints.ecowittApp": "Az alkalmazáskulcs, szintén az Ecowitt fiókjából.",
  "providerHints.myAcuriteCredentialsBanner": "Használja a My AcuRite-fiók e-mailjét és jelszavát — ne a SmartMixin-bejelentkezést.",
  "providerHints.myAcuriteEmail": "A My AcuRite-fiók e-mail címe — nem a SmartMixin-bejelentkezés.",
  "providerHints.myAcuritePassword": "A My AcuRite-fiók jelszava.",
  "providerHints.weatherflowToken": "Személyes token a tempestwx.com → beállítások → adatengedélyek menüpontból.",
  "providerHints.wundergroundEditKey": "Másik kulcs használata",
  "providerHints.wundergroundKey": "Egy hosszú karakterlánc a Weather Underground fiókjának API-kulcs oldaláról — nem a wunderground.com jelszava.",
  "providerHints.wundergroundKeyExample": "pl. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-kulcs ellenőrizve",
  "providerHints.wundergroundKeyVerifying": "Kulcs ellenőrzése…",
  "providerHints.wundergroundNoStationsNearby": "Nem található állomás a hely közelében. Próbálja meg közvetlenül megadni egy állomás azonosítóját.",
  "providerHints.wundergroundStationId": "Bármely Weather Underground állomás-azonosító — sajátja vagy a közelben lévő nyilvános állomás.",
  "providerHints.wundergroundStationIdExample": "pl. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Szerezze be Ambient Weather API-kulcsát.",
  "providerIntro.davisStep2": "Szerezze be Davis V2 API-kulcsát és API-titkát.",
  "providerIntro.ecowittStep2": "Szerezze be Ecowitt API-kulcsát és alkalmazáskulcsát.",
  "providerIntro.getStarted": "Indítás",
  "providerIntro.myAcuriteStep2": "Használja meglévő My AcuRite-fiókja e-mailjét és jelszavát.",
  "providerIntro.netatmoEnergyStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.netatmoWeatherStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.signupBanner": "Majdnem kész — hozzon létre egy ingyenes SmartMixin-fiókot a {provider} csatlakoztatásához.",
  "providerIntro.step1": "Jelentkezzen be a SmartMixin-fiókjába (NEM a {provider}-be).",
  "providerIntro.step3EmailPassword": "Adja meg itt.",
  "providerIntro.step3KeyOrToken": "Illessze be ide.",
  "providerIntro.step3OAuth": "Engedélyezze a SmartMixint a felugró ablakban.",
  "providerIntro.step3Wunderground": "Illessze be az API-kulcsát, majd válasszon egy közeli állomást, vagy adja meg bármely állomás azonosítóját.",
  "providerIntro.title": "{provider} csatlakoztatása",
  "providerIntro.weatherflowStep2": "Szerezze be személyes Tempest tokenjét.",
  "providerIntro.wundergroundBrowsePublic": "Nincs állomása? Tallózzon a nyilvánosak között",
  "providerIntro.wundergroundFindNearby": "Közeli állomások keresése",
  "providerIntro.wundergroundOrEnterId": "Vagy adja meg egy állomás azonosítóját",
  "providerIntro.wundergroundStep2": "Szerezze be Weather Underground API-kulcsát. Ezt követően bármilyen állomást csatlakoztathat — sajátot vagy nyilvánosat.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Elemzés",
  "reports.annualCumulativeRainfallComparison": "Az éves csapadékösszeg összehasonlítása",
  "reports.annualHeatingDurationComparison": "A fűtési idő éves összehasonlítása",
  "reports.annualHeatingEfficiency": "Éves termikus hatásfok",
  "reports.annualIndoorComparison": "Éves beltéri összevetés",
  "reports.annualIndoorReport": "Éves beltéri jelentés",
  "reports.annualOutdoorComparison": "Éves kültéri összevetés",
  "reports.annualOutdoorReport": "Éves kültéri jelentés",
  "reports.annualReport": "Éves jelentés",
  "reports.annualSolarReport": "Éves napelemes jelentés",
  "reports.annualWaterBalance": "Éves vízmérleg",
  "reports.annualWaterBalanceCarryOver": "Előző év átvitele",
  "reports.annualWaterBalanceDescription": "A vízháztartás (egyszerűsített változat, csak eső és evapotranszspiráció használatos) lehetővé teszi a vízkészlet kezelését",
  "reports.avgHumidity": "Átlagos páratartalom",
  "reports.avgMaxTemperature": "Középhőmérsékleti T°max",
  "reports.avgMetric": "Átlagos {metric}",
  "reports.avgMinTemperature": "Középhőmérsékleti T°min",
  "reports.avgPressure": "Légnyomás átlag",
  "reports.avgTemperature": "Középhőmérséklet",
  "reports.climateNormalPeriodOfRecord": "Mérési időszak ({years} év)",
  "reports.climateNormals": "Éghajlati normálértékek",
  "reports.climateNormalStandardLabel": "Standard normálérték ({period})",
  "reports.climateTrendPerDecade": "Hőmérsékleti trend: {value}/évtized ({years} év alatt)",
  "reports.coldestMonthRanking": "A valaha mért leghidegebb {month}",
  "reports.comfortable": "Komfortos (45% {lessThan} Páratartalom ≤ 60%)",
  "reports.cumulativeRainfall": "Csapadékösszeg",
  "reports.cumulativeRainfallDescription": "Kövesse a kiválasztott időszak alatt felhalmozódó teljes csapadékmennyiséget.",
  "reports.dailyMaxRainfall": "Napi csapadék maximum",
  "reports.dataExport": "Adatok exportálása",
  "reports.dataExportXlsxFormatDescription": "Az állomás összes adatának mentése Excel formátumba (* .xlsx). Miután a gombra kattint, néhány perc múlva kap egy emailt a feldolgozott adatokkal.",
  "reports.daysOfData": "{days} napnyi adat",
  "reports.daysWithFrost": "Fagyos napok",
  "reports.daysWithHeavyRain": "Nagy csapadékú napok (≥ {threshold})",
  "reports.daysWithoutThaw": "Napok fagypont alatti maximummal",
  "reports.daysWithStrongFrost": "Erősen fagyos napok",
  "reports.emailSent": "E-mail címedre elküldtük az adatokat",
  "reports.frostDays": "Fagyos napok száma",
  "reports.grasslandTemperatureSum": "A gyephőmérséklet összege",
  "reports.grasslandTemperatureSumDescription": "A növényzet fenntartható helyreállítása, ha az összeg eléri a {threshold}",
  "reports.growingDegreeDays": "Növekedési foknapok",
  "reports.highPressure": "Magas légnyomás (> 1013 mbar)",
  "reports.iceDays": "Téli napok",
  "reports.indoorReport": "Beltéri jelentés",
  "reports.keyFacts": "Statisztika",
  "reports.longestDrySpell": "Leghosszabb száraz időszak",
  "reports.longestRunOfRainyDays": "Az egymást követő esős napok száma",
  "reports.longestRunWithoutRun": "Az egymást követő napok száma eső nélkül",
  "reports.longestWetSpell": "Leghosszabb csapadékos időszak",
  "reports.lowPressure": "Alacsony légnyomás ({lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maximum páratartalom",
  "reports.maxMetric": "Maximális {metric}",
  "reports.maxPressure": "Maximum légnyomás",
  "reports.maxPressureMagnitude24h": "Maximum eltérés (/24H)",
  "reports.maxTemperature": "Hőmérsékleti maximum",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximum eltérés (/24H)",
  "reports.minHumidity": "Minimum páratartalom",
  "reports.minMetric": "Minimális {metric}",
  "reports.minPressure": "Minimum légnyomás",
  "reports.minPressureMagnitude24h": "Minimum eltérés (/24H)",
  "reports.minTemperature": "Hőmérsékleti minimum",
  "reports.minTempMagnitude24h": "Minimum eltérés (/24H)",
  "reports.monthlyAverageCountdown": "Még {days} nap ebben a hónapban",
  "reports.monthlyAverageCountdownDetail": "Ekkor megjelenik a havi átlag és a helyezése.",
  "reports.monthlyAverageRule": "A havi átlagok és helyezések akkor jelennek meg, ha egy naptári hónapban {days} nap van rögzítve.",
  "reports.monthlyHeatingEfficiency": "Havi termikus hatásfok",
  "reports.monthlyIndoorReport": "Havi beltéri jelentés",
  "reports.monthlyOutdoorReport": "Havi kültéri jelentés",
  "reports.monthlyReport": "Havi jelentés",
  "reports.monthlySolarReport": "Havi napelemes jelentés",
  "reports.monthlyWindReport": "Havi széljelentés",
  "reports.monthsOfData": "{months} hónapnyi adat",
  "reports.numberOfDays": "Napok száma",
  "reports.onThisDayInHistory": "Ezen a napon a történelemben",
  "reports.outdoorReport": "Kültéri jelentés",
  "reports.overviewSection": "Áttekintés",
  "reports.rainfall": "Csapadék",
  "reports.rainyDays": "Csapadékos napok",
  "reports.recordDailyRain": "Legcsapadékosabb nap",
  "reports.recordHigh": "Melegrekord",
  "reports.recordLow": "Hidegrekord",
  "reports.recordsAndClimatology": "Rekordok és éghajlat",
  "reports.recordsSince": "Rekordok {date} óta",
  "reports.recordWindGust": "Legerősebb széllökés",
  "reports.relativelyWet": "Viszonylag magas (60% {lessThan} Páratartalom ≤ 80%)",
  "reports.sectionReportCount": "{count} jelentés",
  "reports.sendEmail": "E-mail küldése",
  "reports.summerDays": "Nyári napok",
  "reports.tooDry": "Nagyon alacsony (Páratartalom ≤ 45%)",
  "reports.tooWet": "Nagyon magas (Páratartalom {greaterThan} 80%)",
  "reports.tropicalNights": "Trópusi éjszakák",
  "reports.unlockPremiumSubtitle": "A SmartMixin Premium része",
  "reports.unlockPremiumTitle": "{count} prémium funkció feloldása",
  "reports.warmestMonthRanking": "A valaha mért legmelegebb {month}",
  "reports.waterBalance": "Víz egyensúly",
  "reports.yearsOfData": "{years} évnyi adat",
  "reports.yearToDateTemperatureComparison": "Hőmérséklet-összehasonlítás az év elejétől",
  "sensors.aqiByChannel": "AQI csatornánként",
  "sensors.bgtSensors": "Fekete gömb & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "AQI összehasonlítása",
  "sensors.compareHumidity": "Páratartalom összehasonlítása",
  "sensors.compareMoisture": "Talajnedvesség összehasonlítása",
  "sensors.comparePm25": "PM2.5 összehasonlítása",
  "sensors.compareTemperatures": "Hőmérsékletek összehasonlítása",
  "sensors.depthByChannel": "Mélység csatornánként",
  "sensors.heatStressExtreme": "Extrém hőstressz",
  "sensors.heatStressModerate": "Mérsékelt hőstressz",
  "sensors.heatStressNone": "Nincs hőstressz",
  "sensors.heatStressStrong": "Erős hőstressz",
  "sensors.heatStressVeryStrong": "Nagyon erős hőstressz",
  "sensors.humidityByChannel": "Páratartalom csatornánként",
  "sensors.indoorAirQualityPm": "PM2.5 és PM10 AQI",
  "sensors.indoorClimate": "Beltéri klíma",
  "sensors.indoorCo2Levels": "CO2-szintek",
  "sensors.indoorTemperatureAndHumidity": "Hőmérséklet és páratartalom",
  "sensors.last24Hours": "24 óra",
  "sensors.last30Days": "30 nap",
  "sensors.last7Days": "7 nap",
  "sensors.leafTemperatureByChannel": "Levélhőmérséklet csatornánként",
  "sensors.leafWetnessByChannel": "Levélnedvesség csatornánként",
  "sensors.lightningSensor": "Villám",
  "sensors.moistureByChannel": "Talajnedvesség csatornánként",
  "sensors.noDataAvailable": "Nem áll rendelkezésre adat",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 csatornánként",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Csatorna kiválasztása",
  "sensors.sensorDetailDescription": "Tekintse meg a szenzorcsatornák előzményadatait és trendjeit.",
  "sensors.sensorHistory": "Szenzor előzmények",
  "sensors.soilConductivityByChannel": "Vezetőképesség csatornánként",
  "sensors.soilTemperatureByChannel": "Talajhőmérséklet csatornánként",
  "sensors.strikesToday": "Becsapódások ma",
  "sensors.temperatureByChannel": "Hőmérséklet csatornánként",
  "sensors.viewChart": "Diagram megtekintése",
  "settings.about": "Névjegy",
  "settings.aboutDescription": "Licencszerződés, adatvédelmi irányelvek",
  "settings.account": "Fiók",
  "settings.accountDescription": "Profil, jelszóváltoztatás",
  "settings.accountIntro": "Az alábbi fiókhoz tartozó adatok:",
  "settings.accountOnHoldTitle": "Fiók felfüggesztve",
  "settings.accountSection": "Fiók",
  "settings.addForecastModel": "Modell hozzáadása",
  "settings.appearance": "Megjelenés",
  "settings.appearanceDescription": "Téma és megjelenítési beállítások",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arab",
  "settings.atYourStations": "Elérhető az Ön állomásain",
  "settings.availableServices": "Elérhető",
  "settings.bulgarian": "bolgár",
  "settings.cannotDisconnectLastAccount": "Nem lehet leválasztani az egyetlen bejelentkezési módszert. Kérjük, először adjon hozzá egy másik bejelentkezési módszert.",
  "settings.catalan": "katalán",
  "settings.changeEmail": "E-mail módosítása",
  "settings.changePassword": "Jelszó módosítása",
  "settings.chartGestures": "Gesztusok a diagramokon",
  "settings.chartGesturesDescription": "A diagramon húzva módosíthatja az időszakot, a diagram csippentésével az időskálát változtathatja meg",
  "settings.choiceCount": "{count, plural, one {# elérhető} other {# elérhető}}",
  "settings.connect": "Csatlakoztatás",
  "settings.connected": "Csatlakoztatva",
  "settings.connectedAccounts": "Csatlakoztatott fiókok",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Csatlakoztatva",
  "settings.connectedSince": "Csatlakoztatva {date} óta",
  "settings.connectionSection": "Kapcsolat",
  "settings.connectionSuccess": "{provider} fiók sikeresen csatlakoztatva",
  "settings.contactUs": "Kapcsolat",
  "settings.contactUsDescription": "Segítség vagy visszajelzés küldése",
  "settings.coverageLoading": "Kiszámítjuk, mely állomásait fedi le az egyes modellek…",
  "settings.croatian": "horvát",
  "settings.currentPassword": "Jelenlegi jelszó",
  "settings.czech": "cseh",
  "settings.dailyDetailByPeriods": "Napi részletek napszakok szerint",
  "settings.dailyDetailByPeriodsDescription": "A 24 óra csoportosítása éjszakára, reggelre, délutánra és estére — ugyanaz a felosztás, amit a napi összefoglaló használ.",
  "settings.dangerZone": "Veszélyzóna",
  "settings.danish": "dán",
  "settings.dark": "Sötét téma",
  "settings.dataDisplay": "Adatmegjelenítés",
  "settings.dateAndTime": "Dátum és óra",
  "settings.disconnect": "Leválasztás",
  "settings.disconnectConfirmation": "Biztosan le szeretné választani {provider} fiókját?",
  "settings.disconnectionSuccess": "{provider} fiók sikeresen leválasztva",
  "settings.disconnectProviderDescription": "Leállítja a szinkronizálást. Az előzményei megmaradnak.",
  "settings.donateButton": "Adományozás",
  "settings.donateDescription": "A SmartMixint egy kis csapat fejleszti. Ha hasznosnak találja, egyszeri, tetszőleges összegű adománnyal támogathatja a fejlesztését. Ez egy ajándék — nem módosítja a csomagját, és nem old fel semmilyen funkciót.",
  "settings.donateSuccessBody": "Az adománya segít, hogy a SmartMixin működjön és folyamatosan fejlődjön. Nagyon hálásak vagyunk érte.",
  "settings.donateSuccessTitle": "Köszönjük a támogatását!",
  "settings.donateTitle": "Támogassa a SmartMixint",
  "settings.dragToReorder": "Húzza az átrendezéshez",
  "settings.dutch": "holland",
  "settings.emailChange": "E-mail cím módosítása",
  "settings.emailChangeConfirmation": "E-mail módosítás megerősítése",
  "settings.emailChangeFailure": "Az e-mail módosítási link érvénytelen vagy lejárt.",
  "settings.emailChangeSuccess": "Az e-mail címe sikeresen megváltozott erre: {newEmail}.",
  "settings.emailChangeVerificationSent": "Egy megerősítő e-mailt küldtünk az új e-mail címére. Kérjük, ellenőrizze a bejövő leveleket, és kattintson a linkre a módosítás megerősítéséhez.",
  "settings.english": "angol",
  "settings.everywhereElse": "Mindenhol máshol",
  "settings.everywhereElseFoot": "Minden olyan állomáson használatos, amelyet a kedvenc modelljei nem érnek el.",
  "settings.everywhereElsePick": "Válasszon egyet",
  "settings.fallbackBlend": "SmartMixin keverék",
  "settings.fallbackBlendSub": "Több modellt kombinál, mindegyiket ott, ahol a legerősebb.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES mindenhol, ahová elér.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "A NOAA globális modellje. Ezt használja ma minden fiók.",
  "settings.fallbackResolution": "Legnagyobb felbontás",
  "settings.fallbackResolutionSub": "Az egyes állomásokon elérhető legfinomabb rács.",
  "settings.forecastModels": "Előrejelzési modellek",
  "settings.freeBannerBody": "Az ingyenes fiókok mindenhol GFS-t kapnak — a kedvenc modellek és a „mindenhol máshol” attól a pillanattól működik, hogy előfizet.",
  "settings.freeBannerTitle": "A beállítások Premiummal érvényesek",
  "settings.french": "francia",
  "settings.german": "német",
  "settings.gestures": "Gesztusok",
  "settings.greek": "görög",
  "settings.helpCenter": "Súgóközpont",
  "settings.helpCenterDescription": "GYIK és útmutatók",
  "settings.hungarian": "magyar",
  "settings.integrationsSection": "Integrációk",
  "settings.italian": "olasz",
  "settings.japanese": "japán",
  "settings.korean": "koreai",
  "settings.language": "Nyelv",
  "settings.languageDescription": "Preferált nyelv",
  "settings.light": "Világos téma",
  "settings.measurementUnits": "Mértékegységek",
  "settings.newEmailAddress": "Új e-mail cím",
  "settings.newPassword": "Új jelszó",
  "settings.newPasswordAgain": "Új jelszó megerősítése",
  "settings.norwegian": "norvég",
  "settings.notConnected": "Nincs csatlakoztatva",
  "settings.notificationsSection": "Értesítések",
  "settings.oldPassword": "Régi jelszó",
  "settings.ongoingNotificationEnabled": "Állandó értesítés engedélyezése",
  "settings.ongoingNotificationMetrics": "Megjelenített mérőszámok",
  "settings.ongoingNotificationPermissionRequired": "Értesítési engedély szükséges",
  "settings.ongoingNotificationPreviewHint": "Előnézet — kapcsolja be a widgetet a megjelenítéshez",
  "settings.ongoingNotificationStation": "Meteorológiai állomás",
  "settings.ongoingNotificationStatusBar": "Állapotsor",
  "settings.passwordChange": "Jelszó módosítása",
  "settings.passwordChangeDescription": "Tartsa biztonságban a fiókját",
  "settings.pickerShowAll": "Teljes katalógus megjelenítése",
  "settings.pickerUnreachable": "{count, plural, one {# további modell nem éri el} other {# további modell nem éri el}} egyik állomását sem",
  "settings.pinInUse": "Használatban",
  "settings.pinShadowed": "Soha nincs használatban — egy fenti modell lefedi az összes állomását",
  "settings.pinSlots": "{used} / {max} · koppintson a választáshoz",
  "settings.pinSlotsFull": "Mind a(z) {max} hely foglalt. Távolítson el egyet, hogy másikat adhasson hozzá.",
  "settings.pinsUncoveredCount": "{count, plural, other {# állomásából}} {used}: egyik kedvenc modell sem éri el őket — a „mindenhol máshol” dönt.",
  "settings.pinsUncoveredNamed": "{stations}: egyik kedvenc modell sem éri el {count, plural, one {} other {}}őket — a „mindenhol máshol” dönt.",
  "settings.pinUnreachable": "Soha nincs használatban — egyik állomását sem éri el",
  "settings.pinUsedAt": "Használatban itt: {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Az állomásán használatban} other {Mind a(z) # állomáson használatban}}",
  "settings.pinUsedAtSome": "{count, plural, other {# állomásból}} {used} helyen használatban",
  "settings.polish": "lengyel",
  "settings.portuguese": "portugál",
  "settings.preferencesSection": "Preferenciák",
  "settings.preferredModels": "Kedvenc modellek",
  "settings.preferredModelsAll": "Egy lista, minden állomás",
  "settings.preferredModelsOne": "Egy lista, mindenhol érvényes",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktív",
  "settings.premiumAnnualThenPrice": "Ezt követően 9,99 €/év",
  "settings.premiumAnnualTrialInfo": "Kezdje egy {days} napos ingyenes próbaidőszakkal",
  "settings.premiumCurrentPlan": "Jelenlegi csomag",
  "settings.premiumDescription": "Prémium funkciók feloldása",
  "settings.premiumDownloadApp": "Az előfizetéshez töltse le az alkalmazást:",
  "settings.premiumExpiresOn": "Megújul: {date}",
  "settings.premiumFreePlan": "Ingyenes",
  "settings.premiumInactive": "Nincs előfizetés",
  "settings.premiumManageWebSubscription": "Kezelje előfizetését, frissítse a fizetési módot vagy mondja le.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Éves — 9,99 €/év",
  "settings.premiumSubscribedOn": "Előfizetve itt: {platform}",
  "settings.premiumSubscribeMonthly": "Havi — 1,99 €/hónap",
  "settings.premiumSubscribeOnWeb": "Fizessen elő most az összes prémium funkció feloldásához.",
  "settings.premiumSubscriptionSuccess": "Az előfizetése aktiválva lett! Élvezze az összes prémium funkciót.",
  "settings.premiumSubscriptionSuccessTitle": "Üdvözöljük a Premiumban!",
  "settings.premiumWebappNotice": "Előfizetést csak a SmartMixin mobilalkalmazáson keresztül lehet vásárolni iOS vagy Android rendszeren.",
  "settings.privacyPolicy": "Adatvédelmi irányelvek",
  "settings.profile": "Profil",
  "settings.removePreferredModel": "{model} eltávolítása a kedvenc modellek közül",
  "settings.resetForecastPreference": "Alaphelyzet",
  "settings.resetForecastPreferenceHint": "Törli a kedvenc modelljeit, és visszaáll a SmartMixin alapértelmezésére.",
  "settings.russian": "orosz",
  "settings.seePremium": "Premium megtekintése",
  "settings.serbian": "szerb",
  "settings.servedNowMany": "Jelenleg: GFS {count, plural, one {az Ön állomásán} other {mind a(z) # állomáson}}.",
  "settings.servedNowNone": "Jelenleg: GFS mindenhol.",
  "settings.settings": "Beállítások",
  "settings.signedInAs": "Bejelentkezve mint",
  "settings.slovak": "szlovák",
  "settings.smallDecimals": "Kis tizedesjegyek",
  "settings.smallDecimalsDescription": "Tizedesjegyek kisebb méretben történő megjelenítése",
  "settings.socialConnectionsIntro": "Csatlakoztassa közösségi fiókjait a gyors bejelentkezéshez. Bármikor csatlakoztathatja vagy leválaszthatja a fiókokat.",
  "settings.spanish": "spanyol",
  "settings.statusBarWidget": "Állapotsor widget",
  "settings.statusBarWidgetDescription": "Mindig látható időjárási adatok",
  "settings.subscriptionSection": "Előfizetés",
  "settings.supportSection": "Támogatás",
  "settings.swedish": "svéd",
  "settings.systemTheme": "Rendszer szerinti",
  "settings.termsOfService": "Szolgáltatási feltételek",
  "settings.turkish": "török",
  "settings.ukrainian": "ukrán",
  "settings.units": "Mértékegységek",
  "settings.unitsDescription": "Az alkalmazásban használatos mértékegységek",
  "settings.update": "Frissítés",
  "settings.updateYourProfile": "Adatok frissítése",
  "settings.updateYourProfileDescription": "Név és megjelenítési beállítások",
  "settings.weatherServices": "Időjárási szolgáltatások",
  "settings.weatherServicesConnected": "{count, plural, =0 {Nincs csatlakoztatott szolgáltatás} one {# csatlakoztatott szolgáltatás} other {# csatlakoztatott szolgáltatás}}",
  "settings.weatherServicesDescription": "Csatlakoztassa a Netatmo, Davis, Weatherflow és más eszközöket",
  "settings.windDirectionConvention": "Szélirány nyíl",
  "settings.windDirectionConventionDescription": "Válassza ki a szélirány nyilak megjelenítési módját",
  "settings.windDirectionMeteorological": "Eredet iránya",
  "settings.windDirectionMeteorologicalDescription": "A nyíl azt mutatja, honnan fúj a szél (meteorológiai konvenció)",
  "settings.windDirectionOceanographic": "Áramlási irány",
  "settings.windDirectionOceanographicDescription": "A nyíl azt mutatja, merre fúj a szél (oceanográfiai konvenció)",
  "units.absolutePressure": "Abszolút nyomás",
  "units.airDensity": "Légsűrűség",
  "units.airGap": "Légrés",
  "units.apparentTemperature": "Látszólagos hőmérséklet",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Átlag",
  "units.avg_wind": "Átlagos szél",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Fekete gömb hőm.",
  "units.boilerOn": "Kazán aktivitás",
  "units.co2": "CO2",
  "units.conductivity": "Vezetőképesség",
  "units.coolingDegreeDays": "Lehűlési fokos napok",
  "units.dailyHeatingDuration": "Napi fűtési idő",
  "units.dailyPrecipitation": "Napi csapadék",
  "units.dailyRain": "Napi csapadék",
  "units.degreeDay": "Fokozat-nap",
  "units.degreeDayShort": "DJU",
  "units.depth": "Mélység",
  "units.depthSensors": "Mélységérzékelők",
  "units.dewPoint": "Harmatpont",
  "units.distance": "Távolság",
  "units.downTrend": "Csökkenő trend",
  "units.E": "K",
  "units.E_long": "Keleti",
  "units.ENE": "KÉK",
  "units.ENE_long": "kelet-északkelet",
  "units.ESE": "KDK",
  "units.ESE_long": "kelet-délkelet",
  "units.ET": "Evapotranszspiráció",
  "units.ETshort": "ET",
  "units.feelLike": "Hőérzet",
  "units.feelsLike": "Hőérzet",
  "units.footMile": "láb, mérföld",
  "units.frostPoint": "fagypont",
  "units.gust": "Széllökés",
  "units.heatIndex": "Hőindex",
  "units.heatingDegreeDays": "Fűtési fokos napok",
  "units.heatingPower": "Fűtőteljesítmény",
  "units.humidex": "Humidex",
  "units.humidity": "Páratartalom",
  "units.inch": "Inch",
  "units.inchOfMercury": "Higanyhüvelyk",
  "units.kilometerPerHour": "Kilométer per óra",
  "units.knot": "Csomó",
  "units.last12Hours": "Utolsó 12 óra",
  "units.last24Hours": "Utolsó 24 óra",
  "units.last3Hours": "Utolsó 3 óra",
  "units.last6Hours": "Utolsó 6 óra",
  "units.lastHour": "Előző órában",
  "units.lastLightningImpact": "Utolsó villámcsapás",
  "units.lastMeasure": "Utolsó mérés",
  "units.leafSensors": "Levélérzékelők",
  "units.leafWetness": "A levél nedvessége",
  "units.lightningDistance": "Távolság",
  "units.lightningStrikeCount": "A villámcsapások száma",
  "units.lightningStrikeDistance": "Villámcsapás távolsága",
  "units.max": "Max.",
  "units.max_gust": "Max. széllökés",
  "units.max_wind": "Max. szél",
  "units.meterKilometer": "méter, kilométer",
  "units.meterPerSecond": "Méter per szekundum",
  "units.milePerHour": "Mérföld per óra",
  "units.millibar": "Millibar",
  "units.millimeter": "Milliméter",
  "units.millimeterOfMercury": "Higanymilliméter",
  "units.min": "Min.",
  "units.N": "É",
  "units.N_long": "északi",
  "units.NE": "ÉK",
  "units.NE_long": "északkeleti",
  "units.NNE": "ÉÉK",
  "units.NNE_long": "észak-északkelet",
  "units.NNW": "ÉÉNy",
  "units.NNW_long": "észak-északnyugat",
  "units.noise": "Zaj",
  "units.normalizedHeatingCoefficient": "Normalizált fűtési együttható",
  "units.NW": "ÉNy",
  "units.NW_long": "északnyugat",
  "units.O3": "Ózon",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2.5",
  "units.precipitation": "csapadék",
  "units.pressure": "Légnyomás",
  "units.rain": "Csapadék",
  "units.rainRate": "Eső intenzitása",
  "units.referenceTemperature": "Referencia hőmérséklet",
  "units.relativePressure": "Relatív nyomás",
  "units.S": "D",
  "units.S_long": "déli",
  "units.SE": "DK",
  "units.SE_long": "Délkelet",
  "units.setPoint": "Célérték",
  "units.snow": "Hó",
  "units.snowfall": "Havazás",
  "units.soilMoisture": "Talajnedvesség",
  "units.soilSensors": "Talajérzékelők",
  "units.solarEnergy": "Napenergia",
  "units.solarRadiation": "Napsugárzás",
  "units.speed": "Sebesség",
  "units.SSE": "DDK",
  "units.SSE_long": "dél-délkelet",
  "units.SSW": "DDNy",
  "units.SSW_long": "dél-délnyugat",
  "units.stableTrend": "Stabil trend",
  "units.sum": "Összeg",
  "units.SW": "DNy",
  "units.SW_long": "Délnyugat",
  "units.temperature": "Hőmérséklet",
  "units.temperatureAndHumiditySensors": "Hőmérséklet/nedvesség érzékelők",
  "units.temperatureSensors": "Hőmérséklet/nedvesség érzékelők",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Ma",
  "units.upTrend": "Emelkedés",
  "units.uv": "UV",
  "units.visibility": "Láthatóság",
  "units.W": "Ny",
  "units.W_long": "nyugat",
  "units.wetBulbGlobeTemperature": "Nedves gömb hőm.",
  "units.wetBulbTemperature": "Nedves hőmérséklet",
  "units.wind": "Szél",
  "units.windChill": "Szélhűtés",
  "units.windDirection": "Szélirány",
  "units.windRun": "a szél menete",
  "units.windRunDescription": "A szél útja a szél által egy bizonyos időtartam alatt megtett teljes távolság",
  "units.WNW": "NyÉNy",
  "units.WNW_long": "nyugat-északnyugat",
  "units.WSW": "NyDNy",
  "units.WSW_long": "nyugat-délnyugat"
}
